var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _polygon, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106 123.9",
    style: {
      enableBackground: "new 0 0 106 123.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill:url(#SVGID_19_);}\n\t.st19{fill:url(#SVGID_20_);}\n\t.st20{fill:url(#SVGID_21_);}\n\t.st21{fill:url(#SVGID_22_);}\n\t.st22{fill:url(#SVGID_23_);}\n\t.st23{fill:url(#SVGID_24_);}\n\t.st24{fill:url(#SVGID_25_);}\n\t.st25{fill:url(#SVGID_26_);}\n\t.st26{fill:url(#SVGID_27_);}\n\t.st27{fill:url(#SVGID_28_);}\n\t.st28{fill:url(#SVGID_29_);}\n\t.st29{fill:url(#SVGID_30_);}\n\t.st30{fill:url(#SVGID_31_);}\n\t.st31{fill:url(#SVGID_32_);}\n\t.st32{fill:url(#SVGID_33_);}\n\t.st33{fill:url(#SVGID_34_);}\n\t.st34{fill:url(#SVGID_35_);}\n\t.st35{fill:url(#SVGID_36_);}\n\t.st36{fill:url(#SVGID_37_);}\n\t.st37{fill:url(#SVGID_38_);}\n\t.st38{fill:url(#SVGID_39_);}\n\t.st39{fill:url(#SVGID_40_);}\n\t.st40{fill:url(#SVGID_41_);}\n\t.st41{fill:url(#SVGID_42_);}\n\t.st42{fill:url(#SVGID_43_);}\n\t.st43{fill:url(#SVGID_44_);}\n\t.st44{fill:url(#SVGID_45_);}\n\t.st45{fill:url(#SVGID_46_);}\n\t.st46{fill:url(#SVGID_47_);}\n\t.st47{fill:url(#SVGID_48_);}\n\t.st48{fill:url(#SVGID_49_);}\n\t.st49{fill:url(#SVGID_50_);}\n\t.st50{fill:#C6A246;}\n\t.st51{fill:url(#SVGID_51_);}\n\t.st52{fill:url(#SVGID_52_);}\n\t.st53{fill:url(#SVGID_53_);}\n\t.st54{fill:url(#SVGID_54_);}\n\t.st55{fill:url(#SVGID_55_);}\n\t.st56{fill:url(#SVGID_56_);}\n\t.st57{fill:url(#SVGID_57_);}\n\t.st58{fill:url(#SVGID_58_);}\n\t.st59{fill:url(#SVGID_59_);}\n\t.st60{fill:url(#SVGID_60_);}\n\t.st61{fill:url(#SVGID_61_);}\n\t.st62{fill:url(#SVGID_62_);}\n\t.st63{fill:url(#SVGID_63_);}\n\t.st64{fill:url(#SVGID_64_);}\n\t.st65{fill:url(#SVGID_65_);}\n\t.st66{fill:url(#SVGID_66_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2,43.5c0.2,0,0.7-0.1,0.9-0.1c-1.6-0.5-3.5-0.2-5.1-0.5c-0.7-0.1-1.1-0.4-1.5-0.9c-1.7-1.9-3.5-3.9-5.5-5.8 c-0.2-0.2-0.5-0.3-0.3-0.8c0.2-0.3,0.7-0.3,1-0.4c2.3-0.1,4.6,0.1,6.6,1c3.2,1.1,5.8,2.7,7.9,5.3c0.8,1,1.6,1.9,1.9,3.2 C66,44.1,64,44.1,62.2,43.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6,43.3c0.3-2.9,0.7-5.7,1.1-8.5l0,0c0.1,0.1,0.2,0,0.3-0.1c4.6-1.2,9.1-0.9,13.2,1.7c1.9,1.2,3.5,2.8,4.8,4.7 c-0.1,0.1-0.1,0.3,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c-0.1,0.5,0.3,0.9,0.4,1.3c0.1,0.4,0.7,0.9,0.3,1.4c-0.3,0-0.6-0.1-1-0.1 c-0.2-1.2-1-2-1.6-3c-1.7-2.3-4.1-3.8-6.8-4.9c-1.8-0.6-3.7-1-5.7-0.9c-0.3,0-0.7,0.1-0.9,0.4c-0.1,0.3,0.1,0.4,0.3,0.6 c1.5,1.7,3.1,3.6,4.7,5.3c0.3,0.4,0.7,0.6,1.3,0.7c1.5,0.3,3.1,0,4.5,0.5c-0.2,0-0.5,0.1-0.7,0.1c-4.5-0.3-8.9-0.5-13.3-0.3 C48.3,43.1,47.9,43,47.6,43.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9,63.7C46,63,43.8,61.2,42,59c-6.5-7.8-3.9-20.6,6.5-24.6c0.2-0.1,0.3,0,0.5-0.1c-0.3,2.8-0.7,5.6-1,8.4 c-0.1,4.3-0.2,8.7,0.2,13c-0.1,0.7,0,1.4,0,2.1C48.5,59.8,49,61.7,48.9,63.7z M48,37.7c-0.4-0.1,0.4-1.4-0.6-0.8 c-1.9,0.9-3.6,2.5-4.5,4.4c-0.2,0.4-0.1,0.5,0.3,0.7c1,0.4,2.3,0.2,3.5,0.4c0.2,0.1,0.5-0.1,0.5-0.4C47.5,40.6,47.8,39.2,48,37.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.1667,
    y1: 40.8837,
    x2: 46.0864,
    y2: 40.8837,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.1,75c-2.1,0.8-2.6,1.3-3.1,3.1c-0.7,2.7-1.3,5.2-2.1,7.9c-0.8,2.8-1.2,5.7-2.6,8.4c-0.3,0.7,0,0.7,0.5,0.8 c1.8,0.2,2.7-0.5,3.3-2.6c0.8-3.1,1.4-6.2,2.1-9.3C44.8,80.5,45.4,77.8,46.1,75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.6833,
    y1: 39.3943,
    x2: 59.9166,
    y2: 39.3943,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58,81.2c-0.2-1.6-0.4-3.3-0.7-5c0-0.3,0.1-0.7-0.5-0.8c-1-0.1-2.1,0.9-2.1,1.8c0.1,2.2,0.2,4.6,0.3,6.8 c0.2,3.6,0.3,7.1,0.5,10.7c0,0.7,0.2,1.4,0.5,2c0.4,0.9,1.1,1.2,2.2,1.1c0.9-0.1,1.3-0.7,1.5-1.4c0.2-0.6,0.2-1.3,0.1-2 C59.2,90.1,58.6,85.6,58,81.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.0833,
    y1: 39.4662,
    x2: 51.3333,
    y2: 39.4662,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.8,75.5c-0.5-0.1-0.9-0.1-1,0.6c0,0.8-0.2,1.7-0.4,2.5c-0.6,4.4-1.3,8.8-1.9,13.2c-0.2,1.3-0.5,2.7-0.3,4.1 c0.1,0.9,0.6,1.6,1.6,1.7c1.1,0.1,1.8-0.3,2.2-1.2c0.2-0.5,0.4-1.1,0.4-1.7c0.3-5.5,0.5-11.1,0.9-16.6 C51.5,76.2,51.3,75.9,49.8,75.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.2584,
    y1: 38.5227,
    x2: 54.2917,
    y2: 38.5227,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.1,83.9c0.1-2.4,0.1-4.8,0.1-7.2c-0.7,0.3-0.8,1-1.2,1.3c-0.3-0.4-0.5-0.9-1.1-1.2 c-0.2,6.3-0.3,12.5-0.5,18.7c0,1,0.3,1.8,1.1,2.5c0.4,0.4,0.7,0.3,1.1-0.1c0.6-0.7,0.8-1.5,0.7-2.3C54.2,91.7,54.2,87.7,54.1,83.9z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.1868,
    y1: 40.0345,
    x2: 48.2084,
    y2: 40.0345,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.2,75.6c0.1-0.4-0.1-0.6-0.6-0.7c-0.6,0-1,0-1.2,0.8c-0.9,4.9-1.9,9.8-2.9,14.8c-0.3,1.6-0.8,3.2-1.2,4.8 c-0.2,0.6-0.1,1.1,0.4,1.5s1.1,0.2,1.6,0c0.7-0.4,1-1.1,1.1-1.8c0.4-2.6,0.8-5.2,1.2-7.9C47,83.3,47.6,79.5,48.2,75.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.7885,
    y1: 39.935,
    x2: 63.75,
    y2: 39.935,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.3,84c-0.6-2.8-1.1-5.6-1.7-8.4c-0.1-0.7-0.7-0.6-1.1-0.6s-0.8,0.1-0.6,0.7c0,0.1,0,0.2,0,0.3 c0.9,5.9,1.7,11.9,2.6,17.9c0.1,0.8,0.1,1.7,0.7,2.5c0.6,0.7,1.3,0.9,2,0.6s0.6-1.1,0.4-1.7C62.6,91.5,62.1,87.7,61.3,84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.0833,
    y1: 40.879,
    x2: 67.7083,
    y2: 40.879,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.5,91.7c-1.1-4.4-2.4-8.9-3.3-13.4c-0.4-1.6-1.4-2.6-3-3.3c0.8,3.6,1.6,7.1,2.4,10.6 c0.6,2.6,0.8,5.4,1.8,7.8c0.5,1.5,1.4,2,2.9,1.8c0.5-0.1,0.6-0.2,0.4-0.6C67,93.8,66.7,92.8,66.5,91.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.3747,
    y1: 81.4813,
    x2: 97.9,
    y2: 81.4813,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.9,37.2c-2-14.5-13.2-15.8-13.2-15.8c-9,5.1-13.8,3.1-14.8,3.3s-5.2-6.8-5.2-6.8L58.5,7.1 c-5.4-5.5-12.9-2.8-12.9-2.8c-5,2.5-6.2,5.8-6.2,5.8l-0.2,3.2l2.9-0.1l3.5,0.3l2.4,3.6l-2.6,5.8l0.6,0.2c-1.9,2.1-4.5,3.3-7.6,3.4 c-4.4,0.3-8.5-0.6-12.1-3.2c-0.8-0.6-1.7-1-2.6-1.4c-1.6-0.7-3-0.4-4.4,0.7c-2.4,2.1-4.5,4.5-6.4,7.1c-1.7,2.4-2.7,4.9-2.5,7.9 c0.2,4.7,0.3,9.4,0.4,14.2c0,0.8-0.1,1.5-0.2,2.5c1.5-1.1,2.5-2.3,2.7-3.9c0.3-2.1,0.1-4.2,0.2-6.3c0.1-1.1,0.3-2.2,1.5-3.1 c-0.1,3.7,0.4,7.1,0.1,10.6c1.6-0.8,2.5-2.1,2.8-3.8c0.3-1.5,0.2-3,0.2-4.5c0.1-1.3,0.4-2.6,1.4-3.7c0,3,0.4,6,0.2,9.3 c3.4-2.9,2.6-7.1,4.2-10.7c0,2.9,0.4,5.5,0,8.3c3.4-2.3,2.9-5.8,3.7-9.1c0.6,2.3,0.5,4.5,0.2,6.7c1.4-1,1.6-1.4,3.3-6.9 c-0.4,9.7,0.2,19.3,0.2,29.2c1.8-1.8,2.5-3.7,2.2-5.9c-0.6-5.7-1.2-11.4-0.4-17.2c0.3-1.8,0.5-3.7,1.4-5.4c0,0.4,0,0.8,0,1.2 C34.2,42,34,45,34.1,47.9c0.1,5,1.2,10,1.7,15c0.3,2.7,0.2,5.3-0.4,8c-0.4,1.9-0.8,3.8-1.2,5.7c-0.6,2.2-1.2,4.5-1.9,6.8 c1.2-0.7,2.2-1.3,3.5-2c-0.4,1-0.3,1.8-0.5,2.7c1-0.5,1.1-1.7,2.1-2.2c0,1,0,2,0,3.2c0.9-2.3,1.8-4.3,2.9-6.2h0.1v-0.1 c0.1-0.1,0.1-0.2,0.2-0.3c0.4-0.6,0.9-1.2,1.3-1.8c0.8-1.2,1.9-2.1,3.1-2.7c2.9-1.4,5.7-0.8,8.2,1.3c0.5,0.5,0.8,0.4,1.3,0 c3.6-3,7.6-2.6,10.7,1c1.3,1.5,2.1,3.2,3.1,4.8c0.6,1.4,1.2,2.9,1.7,4.3c0.1,0,0.1,0,0.2,0c0-0.9,0-1.9,0-3c0.7,1,1.3,1.7,2,2.7 c0.1-1.2-0.3-2.1,0-3.1c1,0.6,1.8,1.1,2.9,1.7c-0.5-2-0.9-3.7-1.5-5.4c-0.2-1-0.3-2-0.5-2.9c-0.7-3.4-1.7-6.8-1.4-10.2 c0.2-2.9,0.6-5.7,1.1-8.5c1-5.7,1-11.3,0.3-17c0-0.2-0.1-0.5,0.3-0.6c0.4,0.4,0.4,0.9,0.6,1.4c0.7,2.7,0.9,5.4,1,8.1 c0.1,4.1-0.5,8.2-0.9,12.2c-0.3,2.4,0.6,4.8,2.4,5.8c0.1-7.1,0.2-14.2,0.3-21.3c0-1.4,0.1-2.8-0.2-4.2c-0.2-1.1-0.3-2.3,0.3-3.5 c0.5,2.6,0.9,5.1,3.2,7.1c-0.4-2.4-0.4-4.6,0.2-7c0.6,3.6,0.5,7.2,3.8,9.5c-0.7-2.8-0.3-5.5-0.2-8.4c0.3,0.4,0.4,0.6,0.4,0.9 c0.5,2.1,0.9,4.2,1.4,6.3c0.3,1.3,1.1,2.3,2.3,3.1c0-3.2,0-6.2,0-9.2c0.1,0,0.2,0,0.3,0c0.8,1.1,1.2,2.4,1.2,3.8 c0,1.5-0.1,3,0.2,4.5c0.3,1.7,1.3,2.9,2.8,3.8c-0.2-3.6,0.1-7,0.1-10.6c0.8,0.5,1.1,1.1,1.3,1.8c0.4,1.8,0.2,3.7,0.2,5.5 c-0.1,2.6,0.8,4.6,2.9,6c-0.3-2.6-0.2-5.2-0.1-7.8c0.1-2.7,0-5.4,0.2-8.1c0.1-0.6,0.1-1.2,0.1-1.8L97.9,37.2z M71.2,53.8 c-0.2,0-0.5,0.1-0.5,0.2c-0.1,1.2-1.2,1.6-1.6,2.6c-1.2,2.7-3.2,4.9-5.7,6.6c-0.1,0.1-1.4,0.2-0.3,0.8c0.1,0.1-0.1,0.3-0.2,0.3 c-1.1,0.2-1.1,1.1-1,2.1c-0.7-1-1.6-1.1-2.5-0.6l-0.1,0.1c-0.1-0.1,0-0.1,0.1-0.2c0.1-0.6-0.2-0.5-0.6-0.4 c-1.8,0.6-3.7,0.9-5.7,0.8c-1.6,0-3.1-0.3-4.6-0.7c-0.4-0.1-0.8-0.5-1.3,0c-0.1,0.2-0.6,0-0.6-0.4c-0.2,0.1-0.4,0.1-0.6,0 c0,0.2,0,0.3-0.2,0.2c0,0.2,0,0.3-0.2,0.2c0.1,0.5-0.2,0.5-0.6,0.8c0.3-1.1,0.2-1.9-0.9-2.1c-0.1,0-0.2-0.1-0.2-0.2 c0.9-1-0.4-1-0.7-1.2c-2.5-2-4.3-4.5-5.8-7.4c-0.4-0.8-0.5-2.1-1.9-2.2c-0.3,0-0.3-0.5,0-0.6c0.7-0.3,0.5-0.8,0.5-1.4 c0.2-3.9,0.4-7.9,2.6-11.4C39,39,39,39,38.2,39c0.1-0.6,0.9-1,0.8-1.8c-0.4-0.1-0.6-0.4-0.7-0.9c0.9,0.3,1.6,0.4,2.3-0.5 c0.5-0.7,0.2,0.5,0.7,0.4c2-1.9,4.3-3.4,7-4.3c0.8-0.3,1.7-0.4,2.5-0.7c0.3-0.1,1,0.3,0.9-0.6c0,0,0.2-0.1,0.3-0.1 c1.2,0.3,1.5-0.6,1.7-1.4c0.4,0.2,0.4,0.6,0.5,0.9c0.1,0.2,0.1,0.5,0.3,0.5c1.2-0.1,2,0.8,3.2,1c2.8,0.5,5.3,1.9,7.5,3.8 c0.3,0.3,0.6,1.2,1.3,0.4c0,0,0.3,0.1,0.3,0.2c0.3,0.6,0.9,0.8,1.4,1c0.6,0.4-0.6,0.8,0,1.2c0.6,0.3,0.6,0.3,0.5,1.1 c0,0.2,0.2,0.4,0.3,0.7c1.7,3.1,2.3,6.5,2.2,10c0,0.8,0.1,1.6,0,2.4c0.5-0.1,0.9,0.3,1.3,0.6C71.9,53.5,71.6,53.7,71.2,53.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.3,
    y1: 18.7664,
    x2: 88.7361,
    y2: 18.7664,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.2,99.5c-1.8-1.3-3.7-2.5-5.5-3.9C82.2,95.3,82,95.4,82,96c0,0.3,0,0.6,0.1,0.9c0.2,1,0.1,1.9-0.7,2.4 c-0.2,0.1-0.3,0.3-0.4,0.5c-0.3,0.2-0.7,0.3-1,0.5c-0.1-0.1-0.3-0.2-0.5-0.5c0,0-0.2,0.1-0.3,0.2c-0.3,0.3-0.6,0.5-0.8,0.8 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1-0.1-0.2-0.3-0.3-0.6c-0.5,0.4-0.9,0.8-1.4,1.1c-0.1,0.1-0.5,0.2-0.5,0.1 c-0.1-0.8-1.2-1-1.2-1.8s-0.2-0.9-0.9-0.6c-5.7,2.1-11.6,3.3-17.6,3.6c-0.8,0-1.5,0.1-2,0.8c-0.5,0.6-1,0.5-1.5,0 c-0.4-0.4-0.8-0.8-1.5-0.8c-1.6,0-3.2-0.2-4.8-0.4c-4.5-0.5-8.9-1.5-13.2-3.2c-0.6-0.3-1-0.3-1,0.4c-0.1,0.9-1,1.2-1.4,1.9 c-0.1,0.3-1-0.6-1.5-1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3,0.8-0.3,0.8-0.8,0.3c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.7-0.3,1-1,0.7 c-0.5-0.3-0.9-0.6-1.1-1l-0.2-0.3c-0.4-0.6-0.4-1.4-0.2-2.5c0-0.3,0.2-0.7-0.1-0.9c-0.4-0.3-0.6,0.1-0.8,0.3 c-1.7,1.2-3.5,2.4-5.2,3.7c-0.4,0.3-0.6,0.6-0.6,1.2c0.1,2.6,0,5.2,0.2,7.7c0,0.7,0.2,1.1,0.8,1.4c4,2.2,8.2,4,12.6,5.2 c6.4,1.8,13,3,19.7,3.1c0.7,0,1.3,0.2,1.7,0.8c0.4,0.5,0.8,0.5,1.1,0c0.4-0.5,0.8-0.8,1.5-0.8c5.1,0,10.1-0.8,15.1-1.8 c6.1-1.2,11.9-3.3,17.4-6.3c0.8-0.5,1.2-1,1.2-1.9c0-2.5,0.1-5,0.1-7.5C88.7,100,88.6,99.8,88.2,99.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.077,
    y1: 1038.95,
    x2: 17.7821,
    y2: 1038.95,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.8,77.2c0,3.7,0,7.2,0,10.8c0,2-1.3,3.5-3.6,4.7c0.2-1.5,0.4-2.8,0.2-4c-0.1-2.9-0.1-5.7-0.1-8.7 c0-0.5,0.1-0.7,0.6-0.8C15.8,78.6,16.8,78.1,17.8,77.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4,9c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.3C39.5,9.1,39.5,9.1,39.4,9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.9818,
    y1: 1046.3547,
    x2: 35.2026,
    y2: 1046.3547,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M32.9,95.6c0,0.3,0.1,0.6,0.2,1c-0.4-1.1-1.9-1.7-0.9-3.2c0.7-1,1.1-2.3,1.8-3.5c0.7-1,1.2-2.3,1.1-3.8 c-0.6,0.4-0.8,1.1-1.5,1.4c-0.4-1-0.1-2.1-0.5-3.1c-1.1,0.8-1.8,1.7-1.8,3.1c0,0.2-0.1,0.5-0.2,0.7c-0.7,1.7-1.4,3.3-1.9,5.1 c-0.1,0.2-0.2,0.6,0.2,0.5c0.8-0.2,0.4,0.3,0.4,0.6c0.1,1.5-0.5,2.9-0.9,4.4c-0.2,0.9,0.1,1.4,0.9,1.5c1,0.1,1-0.6,1.1-1.3 c0.1-0.8,0.1-1.6,0.2-2.4c0-0.2,0-0.6,0.3-0.6c0.3-0.1,0.4,0.2,0.6,0.5c0.3,0.4,0.5,0.9,0.9,1.3c0.2,0.1,0.5,0.3,0.5,0 s0.1-0.5,0.1-0.5C33.3,96.7,33.1,96.1,32.9,95.6z M30.3,93.6c0-0.1,0-0.2,0.1-0.2c0.3-0.2,0.5-0.1,0.8,0.3 C30.8,93.6,30.6,93.6,30.3,93.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.6997,
    y1: 1045.3837,
    x2: 13.0936,
    y2: 1045.3837,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M13.1,80.1c0,2.2,0,4.1,0,6.1c0,3.9,0,7.8,0,11.8c0,1.9-0.9,3.3-2.5,4.4c-0.2,0.1-0.5,0.4-0.7,0.2 c-0.2-0.2-0.1-0.5,0-0.7c0.3-0.7,0.3-1.4,0.3-2.2c0-5.6,0-11.2,0-16.8c0-0.6,0.1-0.9,0.7-1.3C11.6,81.3,12.2,80.7,13.1,80.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.8922,
    y1: 1045.6414,
    x2: 96.0567,
    y2: 1045.6414,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M93,80.2c0.8,0.6,1.5,1.3,2.4,1.8c0.4,0.2,0.2,0.6,0.2,1c0,5.7,0,11.5,0,17.2c0,0.7,0,1.4,0.3,2.1 c0.1,0.2,0.2,0.5,0,0.7c-0.3,0.2-0.5,0-0.7-0.2c-1.4-1-2.3-2.3-2.3-4.1c0-6.1,0-12.2,0-18.3C92.9,80.5,93,80.5,93,80.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.3648,
    y1: 1039.6,
    x2: 91.6648,
    y2: 1039.6,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M88.4,77.7c0.6,0.7,1,1.2,1.5,1.4c1.7,0.4,1.8,1.6,1.8,2.9c-0.1,2.9-0.1,5.9-0.2,8.8c0,0.9,0.1,1.8,0.2,2.7 c-1.8-0.5-3.2-2.6-3.3-4.7C88.4,85.2,88.4,81.6,88.4,77.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.7108,
    y1: 1034.45,
    x2: 86.9012,
    y2: 1034.45,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.9,87.8c-2-1.2-3.1-2.8-3.1-4.8c0-3.2,0-6.4,0-9.9c1,0.9,2,1.6,3,2.2c0.2,0.1,0.2,0.4,0.2,0.6 C86.9,79.8,86.9,83.7,86.9,87.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.8493,
    y1: 1034.15,
    x2: 21.9361,
    y2: 1034.15,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M21.9,73c0,3.5,0.1,6.7,0,10c-0.1,1.9-1.2,3.3-3,4.3c0-4,0-7.8,0-11.6c0-0.4,0.2-0.6,0.5-0.7 C20.3,74.5,21,73.9,21.9,73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.1599,
    y1: 1011.65,
    x2: 17.5954,
    y2: 1011.65,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M17.6,51.5c-0.2,2.9,0.3,5.7-0.3,8.4c-0.3,1.8-1.4,3.1-3.2,3.9c0.4-3.3,0.3-6.5,0.3-9.6c0-0.4,0.3-0.6,0.6-0.8 C15.8,52.8,16.6,52.2,17.6,51.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.6922,
    y1: 1014.3,
    x2: 13.1101,
    y2: 1014.3,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M9.7,66.3c0.5-3.1,0.3-6,0.3-9.1c0-0.7,0.2-1.1,0.8-1.4c0.7-0.4,1.4-0.9,2.3-1.5c-0.1,2.8,0.2,5.4-0.1,8 C12.7,64.1,11.6,65.5,9.7,66.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.7833,
    y1: 1012.15,
    x2: 92.0927,
    y2: 1012.15,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M88.8,52.1c1,0.7,1.9,1.4,2.8,2c0.3,0.2,0.2,0.4,0.2,0.6c0,3.1-0.1,6.3,0.3,9.5c-1.8-0.6-3.2-2.5-3.3-4.6 C88.8,57.1,88.8,54.7,88.8,52.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.2499,
    y1: 1014.95,
    x2: 96.7797,
    y2: 1014.95,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M96.8,67.1c-2.2-0.9-3.6-2.8-3.6-4.9c0-2.4,0-4.7,0-7.4c1,0.7,1.9,1.2,2.7,1.9c0.4,0.3,0.3,0.6,0.3,1 c0.1,2.7-0.2,5.4,0.2,8C96.6,66.1,96.8,66.5,96.8,67.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.7437,
    y1: 1043.3,
    x2: 77.0873,
    y2: 1043.3,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M74.6,94.4c-1.1-0.2-1.1-1.1-1.2-1.9c-0.2-0.7-0.5-1.2-1-1.8c-1.1-1.2-1.4-2.9-1.6-4.6 c0.4,0.4,0.9,0.9,1.4,1.5c0.5-1,0.2-2.2,0.4-3.4c0.9,0.8,1.7,1.5,1.9,2.6c0.3,1.6,0.9,3.1,1.7,4.6c0.4,0.7,0.5,1.8,0.8,2.7 c-0.9-0.3-1.6-1.4-2.4-0.1l0,0C74.6,94.2,74.4,94.2,74.6,94.4L74.6,94.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.3808,
    y1: 1009.85,
    x2: 87.7392,
    y2: 1009.85,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M87.7,62.1c-2.2-1.2-3.1-2.9-3.3-4.7c-0.2-2.6-0.1-5-0.1-7.8c1,0.6,1.9,1.1,2.7,1.5c0.3,0.1,0.3,0.4,0.3,0.6 C87.6,55.2,87.4,58.5,87.7,62.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.9,
    y1: 1009.25,
    x2: 21.8158,
    y2: 1009.25,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M18.9,61.1c0.2-3.1,0.1-6,0.1-9c0-0.8,0.2-1.4,1-1.7c0.6-0.2,1.1-0.6,1.8-1c0,1.9,0,3.6,0,5.4 c0,1,0.1,2.1-0.3,3.1C21,59.2,20.4,60.4,18.9,61.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.6373,
    y1: 1004.4,
    x2: 79.5563,
    y2: 1004.4,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M76.8,44.2c0.1,0.1,0.1,0.1,0.2,0.1c1.8,1.3,2.7,2.8,2.4,5.1c-0.2,2.3-0.2,4.7,0.1,7.2 c-1.9-0.9-2.9-2.3-2.9-4.2c0-2.7-0.1-5.3-0.1-8C76.7,44.3,76.7,44.2,76.8,44.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.0616,
    y1: 1003.9,
    x2: 29.9253,
    y2: 1003.9,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M27.2,56.1c0-2.5,0.2-5-0.1-7.5c-0.3-2.3,0.9-3.6,2.7-4.9c0.2,1.5-0.1,3-0.1,4.5c0,1.2-0.1,2.5,0,3.7 C29.9,53.8,28.8,55.1,27.2,56.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.1132,
    y1: 1007.2,
    x2: 83.2575,
    y2: 1007.2,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M83.3,59.2c-2.3-1.5-3.2-3.3-3.2-5.5s0-4.3,0-6.5c2,0.7,2.8,1.7,2.8,3.7C82.9,53.6,82.7,56.4,83.3,59.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.4354,
    y1: 1029.7,
    x2: 25.7684,
    y2: 1029.7,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M25.8,69.7c0,2.9,0.1,5.7,0,8.4c-0.1,1.4-0.8,2.7-2.3,3.6c0-3.3,0-6.5,0-9.7c0-0.2,0-0.4,0.2-0.6 C24.3,71,25,70.4,25.8,69.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.0226,
    y1: 1019.7617,
    x2: 22.0081,
    y2: 1019.7617,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M19.1,69.9c0-2.2,0-4.3,0-6.5c0-0.3,0.1-0.5,0.4-0.7c0.8-0.4,1.6-0.8,2.5-1.3c0,2.1,0,4.1,0,6 c0,0.6,0.1,1.3-0.3,1.9C20.9,70,20,70.4,19.1,69.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.8751,
    y1: 1006.8,
    x2: 25.7697,
    y2: 1006.8,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M25.8,46.8c0,2.6,0.1,5,0,7.5c-0.1,1.9-1.1,3.3-2.9,4.5c0.7-3.2,0.4-6.3,0.4-9.4c0-0.4,0-0.7,0.4-0.9 C24.3,48,25,47.5,25.8,46.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.0465,
    y1: 1020.7346,
    x2: 86.925,
    y2: 1020.7346,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M84.5,70.7c-0.5-1.2-0.4-2.3-0.4-3.6c0-1.5,0-2.8,0-4.3c0-0.7,0.2-0.8,0.8-0.4c0.5,0.3,1,0.6,1.5,0.8 c0.3,0.1,0.4,0.3,0.4,0.6c-0.1,2.3,0.1,4.6,0.2,6.9c-0.3,0.8-0.8,0.7-1.4,0.3C85.2,71,85,70.5,84.5,70.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.2137,
    y1: 1023.2,
    x2: 29.7194,
    y2: 1023.2,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M27.2,75.1c0-3,0-5.9,0-8.8c0-0.4,0.2-0.6,0.4-0.9c0.7-0.5,1.3-1.1,2-2.1c0,1.3,0,2.4,0,3.5c0,1.2,0,2.3,0,3.5 C29.7,72.8,29.3,73.6,27.2,75.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.3539,
    y1: 1021.9,
    x2: 17.5432,
    y2: 1021.9,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M14.5,72.5c-0.2-2-0.1-4.1-0.1-6.3c0-0.3,0.1-0.6,0.4-0.9c0.9-0.6,1.7-1.3,2.7-2c0.3,2.4-0.2,4.7,0.1,7 c-0.2,0.5-0.3,1.2-1,1.4C15.8,72.1,15.2,72.3,14.5,72.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.5948,
    y1: 1024.05,
    x2: 78.9806,
    y2: 1024.05,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M76.6,64.3c0.7,0.6,1.3,1.3,2.1,1.8c0.3,0.2,0.3,0.5,0.3,0.8c0,2.8,0,5.8,0,8.9c-1.2-1.2-2.4-2.1-2.4-3.9 C76.6,69.4,76.6,66.8,76.6,64.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.0061,
    y1: 1029.8,
    x2: 82.5737,
    y2: 1029.8,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M82.6,81.9c-1.5-0.9-2.5-2.1-2.5-3.4c-0.1-2.8,0-5.7,0-8.8c0.8,0.6,1.5,1.1,2.2,1.7c0.4,0.2,0.4,0.5,0.4,0.8 C82.6,75.3,82.6,78.5,82.6,81.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.2581,
    y1: 1018.111,
    x2: 25.6784,
    y2: 1018.111,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M25.6,59.2c0.2,2.6,0,5-0.3,7.3c-0.1,1.1-1,1.7-1.6,2.4c-0.2,0.3-0.5,0-0.5-0.4c0-2.5,0-5,0.1-7.4 c0-0.3,0.2-0.5,0.4-0.7C24.3,60.1,24.9,59.7,25.6,59.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.2208,
    y1: 1018.75,
    x2: 82.5367,
    y2: 1018.75,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M80.3,59.7c0.8,0.5,1.3,0.9,1.9,1.3c0.2,0.2,0.4,0.4,0.4,0.7c0,2.7,0,5.3,0,8.1c-1.4-0.8-1.9-2.1-2.1-3.6 C80.1,64.2,80.3,62,80.3,59.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.5613,
    y1: 52.3,
    x2: 96.9078,
    y2: 52.3,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.1,73.6c-0.2,0.1-0.3,0.2-0.5,0.1C95.8,73.7,96,73.7,96.1,73.6c0.4-1.5,0.1-2.9,0.1-4.5 c0-0.2-0.1-0.3-0.2-0.4c-1-0.7-2.1-1.3-3.4-2c0,2.4,0,4.6,0,6.7c-0.1,1.9-0.1,3.8,1.2,5.5c0.9,1.1,1.7,1.6,3,1.8 C95.8,78.4,96.3,76,96.1,73.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.969,
    y1: 1024.3842,
    x2: 12.9941,
    y2: 1024.3842,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M10.1,74.1c0-1.8,0-3.6-0.1-5.3c0-0.7,0.5-0.9,0.9-1.1c0.6-0.4,1.2-1.2,1.7-1s0.1,1.2,0.1,1.8 c-0.1,1.4,0.5,2.8,0.2,4.3C11.9,73.1,10.7,73,10.1,74.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.8093,
    y1: 1030.35,
    x2: 13.0802,
    y2: 1030.35,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M9.6,73.7c0.7-1.3,2.3-1.1,3.5-1.5c0,1.9,0.4,3.9-0.7,5.6c-0.7,1.1-1.7,2.2-3.5,2.7c1-1.7,0.7-3.4,0.8-5 c0.2-0.3,0.2-0.8,0-1.1C9.6,74.2,9.6,74,9.6,73.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.0421,
    y1: 54.95,
    x2: 91.5713,
    y2: 54.95,
    gradientTransform: "matrix(1 0 0 -1 0 126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M91.4,71.1c0-0.1,0.1-0.2,0.1-0.3c0-1.4,0-2.8,0-4.2c0-0.2-0.1-0.4-0.2-0.5c-1-0.6-2-1.2-3.1-1.9 c0,2.4,0,4.5,0,6.7c0.6,0.5,1.3,0.6,2.1,0.8c0.1,0,0.2,0,0.2,0c-0.1,0-0.2,0-0.4,0c-0.7-0.2-1.5-0.3-2-0.8c0,0.8-0.1,1.6,0,2.4 c0.1,2.1,1.2,3.5,3.5,4.6C91.4,75.5,91.4,73.3,91.4,71.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.1907,
    y1: 1051.4122,
    x2: 77.0806,
    y2: 1051.4122,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M74.6,93.8c1.5,0.2,1.6,0.2,1.6,1.9c0,1.2,0.6,2.1,0.7,3.2c0,0.3,0.1,0.7,0.1,1.1c0,0.6-0.5,0.8-1.1,1 c-0.5,0.1-0.8-0.1-1.1-0.7c-0.2-0.7-0.1-1.6-0.1-2.3c0-0.6,0-1.2-0.4-1.6c-1,0.4-0.8,1.8-2.2,2c0.5-1.4,1.3-2.3,1.9-3.4 c0.1-0.3,0.6-0.4,0.3-1l0,0c0.1,0,0.1,0.1,0.3,0C74.8,94,74.7,93.9,74.6,93.8L74.6,93.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.4389,
    y1: 1014.25,
    x2: 78.9594,
    y2: 1014.25,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M79,64.3c-1.6-0.9-2.4-2-2.5-3.6c-0.1-1.4,0-2.9,0-4.5c0.7,0.9,1.3,1.6,2,2.2c0.2,0.2,0.3,0.4,0.3,0.7 C78.8,60.7,78.7,62.4,79,64.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8946,
    y1: 1013.5274,
    x2: 29.4564,
    y2: 1013.5274,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M29.5,55.8c0,1.5,0,2.9,0,4.3c0,1.3-0.7,2.3-1.8,3c-0.4,0.2-0.7,0.3-0.6-0.3c0.1-1.5,0.1-3,0.2-4.5 c0-0.2,0.1-0.4,0.3-0.5C28.2,57.2,28.6,56.4,29.5,55.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.4574,
    y1: 1027.65,
    x2: 17.6109,
    y2: 1027.65,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M14.4,72.1c0.6-0.2,1.4-0.5,2-0.7c0.8-0.2,0.9-0.7,1.1-1.4c0,1.2,0.1,2.4-0.2,3.6c-0.4,1.7-1.4,3-3,3.7 C14.4,75.7,14.4,73.9,14.4,72.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.207,
    y1: 1049.9137,
    x2: 26.8116,
    y2: 1049.9137,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M24.2,97.6c0.4-1.3,0.3-2.8,0.4-4.2c0-0.8,0.5-1,1.2-0.5c0.6,0.4,1.2,1.4,1,1.8C26,95.9,27,97,26.6,98.1 c-0.2,0.7-0.8,1.1-1.4,1.1C24.4,99.2,24.3,98.4,24.2,97.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.8385,
    y1: 1049.9719,
    x2: 81.8629,
    y2: 1049.9719,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M81.4,94.9c-0.1,0.8,0.1,1.6,0.3,2.3c0.2,0.7,0,1.3-0.6,1.7c-0.3,0.3-0.9,0.2-1.3,0c-0.7-0.3-0.9-0.9-0.8-1.5 c0-0.5,0.1-0.9,0.1-1.3c0-0.3,0.6-0.9-0.3-1c-0.2,0,0.1-0.5,0.2-0.7c0.1-0.3,0.3-0.6,0.4-0.8c0.3-0.4,0.8-0.9,1.4-0.7 c0.7,0.2,0.3,0.8,0.4,1.2C81.4,94.4,81.4,94.7,81.4,94.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.3003,
    y1: 1050.8724,
    x2: 79.3294,
    y2: 1050.8724,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M77.3,97.5c0-0.4,0-0.8,0-1.2c0-0.2,0-0.3-0.2-0.4c-0.7-0.2-0.9-0.6-0.7-1.2c0.3-0.7,0.9-1,1.6-1.1 c0.3,0,0.3,0.3,0.4,0.5c0.2,0.5,0.1,1.1,0.1,1.8c0,0.9,0,2,0.5,2.9c0.3,0.6,0.1,1.1-0.5,1.3c-0.8,0.2-1.2-0.3-1.3-0.9 C77.2,98.6,77.3,98.1,77.3,97.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.725,
    y1: 1050.4957,
    x2: 29.4456,
    y2: 1050.4957,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M29.3,96.1c-0.2-0.1-0.2-0.4-0.5-0.4s-0.3,0.3-0.3,0.5c0,0.8,0,1.7,0,2.5c0,0.6-0.5,0.9-1.1,0.9 c-0.6-0.1-0.8-0.6-0.6-1c0.6-1.3,0.4-2.7,0.6-4.1c0.1-0.4-0.1-1.2,0.6-1.1c0.6,0,1.2,0.4,1.4,1.1C29.6,95,29.4,95.4,29.3,96.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.041,
    y1: 1025.15,
    x2: 21.541,
    y2: 1025.15,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M19.1,69.9c1,0.4,1.7,0,2.5-0.5c-0.2,1.5-1.1,2.6-2.5,3.5C19.1,71.8,19.1,70.9,19.1,69.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.4509,
    y1: 1025.8231,
    x2: 86.925,
    y2: 1025.8231,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M84.5,70.3c0.5-0.2,0.7,0.2,1.1,0.5c0.6,0.4,1.1,0.5,1.4-0.3c0,0.9,0,1.9,0,2.9C85.6,72.7,84.8,71.7,84.5,70.3 z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M10.1,74.7c0.2,0.3,0.2,0.7,0,1C10,75.3,10,75,10.1,74.7z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M96.4,54.5L96.4,54.5L96.4,54.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.8679,
    y1: 961.2,
    x2: 57.0059,
    y2: 961.2,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M57,7.1c0,0.1,0,0.1,0.1,0.2C57.1,7.3,57,7.3,57,7.1C56.9,7.2,56.9,7.2,57,7.1L57,7.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.6269,
    y1: 1032.45,
    x2: 39.8387,
    y2: 1032.45,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M39.6,78.6c0.1-0.1,0.1-0.2,0.2-0.3C39.8,78.4,39.7,78.5,39.6,78.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.676,
    y1: 1032.45,
    x2: 63.8321,
    y2: 1032.45,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M63.8,78.5c-0.1,0-0.1,0-0.2,0v-0.1C63.7,78.4,63.8,78.4,63.8,78.5L63.8,78.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.0824,
    y1: 1001.8689,
    x2: 71.6237,
    y2: 1001.8689,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M68.2,37.3c0.6,0.4-0.6,0.8,0,1.2c0,0.7-0.7,0.1-0.8,0.4c3,3.9,3.8,8.4,3,13.2c-0.2,0-0.3-0.1-0.5-0.1 c-0.4-0.2-0.6-0.5-1.2-0.5c0.3,0.4,0.2,1.3,1,0.6c0.2,0.3,0.5,0.5,0.8,0.1c0.2,0,0.5-0.7,0.5,0.1c0,0.2-0.3,0.6,0.2,0.6l0,0 c-0.1,0.2,0.8,0.4,0.1,0.5c-0.7,0.1-0.7,0.5-0.8,1.1c-0.2-1-1-0.7-1.6-1c0.1-0.1,0.1-0.1,0.2-0.2c0.2,0,0.3-0.2,0.3-0.2 c-0.2-0.2-0.3,0-0.4,0.1s-0.1,0.1-0.2,0.2c-0.2,0.2-0.5,0.2-0.4,0.6c0.5,0,1-0.2,1.5,0c-1.2,3.8-3.6,6.9-7,9.1 c-1.2,0.8-1.2,0.8-1.3-0.7l-0.1-0.1c-0.3,0.1-0.3,0.4-0.4,0.6c0,0.1-0.1,0.2-0.1,0.3c-0.5,0.7-1.2,0-1.9,0.2 c0.2,0.3,0.5,0.7,0.8,0.8c0.1,0.6-0.4,0.5-0.8,0.6c-3.9,1.3-7.8,1.2-11.7,0c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1,0.3-0.5-0.2-0.4 c-0.2,0.1-0.4,0.3-0.2,0.6c0.1,0.2,0.6,0.6-0.2,0.5l0,0c-0.2-0.2-0.4-0.4-0.7,0l0,0c-0.1,0.1-0.1,0.1-0.2,0.2l0,0 c-0.1,0.1-0.1,0.1-0.2,0.2l0,0c-0.4-0.4,0.1-1.3-0.8-1.4c0,0-0.1-0.2,0-0.2c1-0.7-0.1-0.8-0.4-0.9c-3-2-5.2-4.7-6.7-7.9 c-0.7-1.6-0.7-1.6,1-1.6l0.1-0.1c-0.3-0.2-0.5-0.5-0.8-0.7c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.2,0.1-0.4,0.1-0.5c0.1-0.3,0.4-0.5,0.3-0.9 c-0.3-0.1-0.5,0.2-0.7,0.3c-0.6,0.4-0.9,0.2-0.9-0.5c-0.1-1.3-0.2-2.6,0-4.1c0.3-2.9,1.3-5.6,3.2-8c0.3,0.4,0.6,0.7,0.9,1.1 c0.2-0.6-0.1-1.2,0.3-1.6c0.3-0.3,1-0.2,1.3-0.6c-1.2-0.5-1.2-0.5-0.3-1.4c2.4-2.2,5.2-3.6,8.4-4.4c0.7-0.2,1.5-0.3,2.4-0.3 c0.3,0,0.1,0.6,0.4,0.3c0.2-0.2-0.1-0.4-0.3-0.6c-0.1-0.1-0.3-0.2-0.2-0.5c0.7,0.3,1-0.3,1.3-0.9c0,0.8,0.6,1,1.5,0.9 c-0.7,0.5-0.9,0.9-0.7,1.6c-0.4-0.1-0.7-0.3-1.2,0c0.8-0.1,1.1,0.6,1.8,0.8c-0.1-0.5-0.3-1-0.4-1.5c3.7-0.3,10,2.8,11.8,5.8 c-0.3,0.4-0.9,0.2-1.2,0.7c0.6,0,1,0.4,1.6,0.2c-0.1-0.3-0.6,0-0.7-0.5c0.6-0.1,0.9-0.5,0.8-1.2C67.2,37.5,67.7,37.5,68.2,37.3z  M65.9,41c0-0.1,0-0.2-0.1-0.3c-1.1-1.7-2.7-3.2-4.5-4.4c-3.9-2.4-8-2.7-12.4-1.6c-0.1,0-0.2,0-0.3,0.1l0,0c-0.2,0-0.3,0-0.5,0.1 c-10,3.7-12.5,15.9-6.2,23.2c1.7,2,3.8,3.7,6.5,4.5c0.2,0.1,0.3,0.2,0.5,0.2c5.7,1.9,12.7-0.2,16.3-5.1c0.8-1.1,1.5-2.2,1.9-3.5 c-6.4,1.6-12.9,1.3-19.3,0.9c-0.4-4.1-0.3-8.2-0.2-12.3c0.3-0.3,0.7-0.2,1.1-0.3c4.2-0.3,8.3-0.1,12.5,0.3c1.5,0.4,3.1,0.5,4.7,0.7 c0.3,0,0.6,0.1,0.9,0.1c0.5,0.3,0.6,0.1,0.4-0.4C66.9,42.5,66.6,41.7,65.9,41C66,41.1,65.9,41.1,65.9,41z M52.4,32.4 c-0.1,0.3-0.4,0.6-0.2,0.9C52.8,33.2,52.8,32.9,52.4,32.4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2,62.6c0.1-0.2,0.1-0.5,0.4-0.6l0.1,0.1c0.1,1.5,0.1,1.5,1.3,0.7c3.3-2.2,5.6-5.2,6.8-9c-0.5-0.2-1,0-1.5,0 c-0.1-0.4,0.3-0.4,0.4-0.6l0.1,0.1c0.5,0.3,1.4,0,1.6,1c0.2-0.5,0.1-1,0.8-1.1c0.8-0.1-0.2-0.3-0.1-0.5c0.6-0.1,0.9,0.3,1.3,0.6 c-0.4,0.2-0.7,0.4-1.1,0.5c-0.2,0-0.5,0.1-0.5,0.2c-0.1,1.2-1.2,1.6-1.6,2.6c-1.2,2.7-3.2,4.9-5.7,6.6c-0.1,0.1-1.4,0.2-0.3,0.8 c0.1,0.1-0.1,0.3-0.2,0.3c-1.1,0.2-1.1,1.1-1,2.1c-0.7-1-1.6-1.1-2.5-0.6l0,0c0.1-0.6-0.2-0.5-0.6-0.4c-1.8,0.6-3.7,0.9-5.7,0.8 c-1.6,0-3.1-0.3-4.6-0.7c-0.4-0.1-0.8-0.5-1.3,0c-0.1,0.2-0.6,0-0.6-0.4c0.8,0.1,0.3-0.4,0.2-0.5c-0.2-0.3,0-0.5,0.2-0.6 c0.4-0.1,0,0.3,0.2,0.4s0.4,0.3,0.6,0.3c3.8,1.3,7.6,1.4,11.4,0c0.3-0.1,0.8,0,0.8-0.6l0.1-0.1c0.6,0.3,0.1,0.8,0.1,1.3 c0.6-0.4,1-0.1,1.6,0.4c-0.4-1,0.1-1.3,0.7-1.6c-1,0-0.9-0.8-1.3-1.3C61.2,62.7,61.2,62.6,61.2,62.6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9,9.5c-1.4,0.9-2.7,0.3-2.9-1.4c-0.1-0.7-0.2-1-1-0.7c-0.2,0.1-0.4,0.1-0.5-0.1c0-0.1,0-0.4,0.1-0.5 c0.4-0.5,1-0.7,1.7-0.7c1.6,0,3.2,0,4.8,0.3c-0.2,0.2-0.4,0.1-0.6,0.1c-0.5,0-0.8,0.2-0.6,0.8c0.1,0.4,0.2,0.9-0.1,1.3 c0-0.2-0.1-0.5-0.2-1C48.1,9,47.3,9.3,46.3,9c-0.1,0-0.2-0.1-0.3,0s0,0.1,0.1,0.2C46.6,9.6,47.3,9.4,47.9,9.5z M47.8,7.1 c-0.1-0.3-0.4-0.5-0.7-0.5s-0.9,0.1-0.7,0.5c0.2,0.5,0.8-0.2,1.2,0.2C47.7,7.4,47.8,7.2,47.8,7.1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3,51.6c0.8-4.7,0-9-2.9-13c0.1-0.3,0.8,0.3,0.8-0.4c0.6,0.3,0.6,0.3,0.5,1.1c0,0.2,0.2,0.4,0.3,0.7 c1.7,3.1,2.3,6.5,2.2,10c0,0.8,0.1,1.6,0,2.4C70.7,52.3,71,52,71,51.8c0-0.8-0.3-0.1-0.5-0.1C70.4,51.7,70.4,51.7,70.3,51.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.9268,
    y1: 961.1,
    x2: 56.9658,
    y2: 961.1,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M57,7.1L57,7.1C56.9,7.1,56.9,7.1,57,7.1L57,7.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.1628,
    y1: 966.3472,
    x2: 43.5354,
    y2: 966.3472,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M40.2,12.8c1.2,0.3,2.2-0.2,3.4-0.2C42.2,11.5,41.6,11.5,40.2,12.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.5324,
    y1: 1006.4,
    x2: 70.5363,
    y2: 1006.4,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "70.6,52.4 70.6,52.4 70.5,52.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.4,
    y1: 991,
    x2: 38.4,
    y2: 991,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M38.4,37L38.4,37L38.4,37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.4,
    y1: 1008.5,
    x2: 96.4,
    y2: 1008.5,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M96.4,54.5L96.4,54.5L96.4,54.5L96.4,54.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.5,
    y1: 1018.8,
    x2: 45.5,
    y2: 1018.8,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M45.5,64.8L45.5,64.8L45.5,64.8L45.5,64.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.2,
    y1: 1018.8,
    x2: 46.2,
    y2: 1018.8,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M46.2,64.8L46.2,64.8L46.2,64.8L46.2,64.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.1,
    y1: 1019.2,
    x2: 45.1,
    y2: 1019.2,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M45.1,65.2L45.1,65.2L45.1,65.2L45.1,65.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.3,
    y1: 1019,
    x2: 45.3,
    y2: 1019,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M45.3,65L45.3,65L45.3,65L45.3,65z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5,64.8c0.2-0.4,0.4-0.2,0.7,0C46,64.9,45.7,64.9,45.5,64.8z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,65c0.1-0.1,0.1-0.1,0.2-0.2C45.6,65,45.5,65.1,45.3,65z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1,65.2c0.1-0.1,0.1-0.1,0.2-0.2C45.4,65.2,45.3,65.3,45.1,65.2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M59,65.4L59,65.4C58.8,65.5,58.9,65.4,59,65.4L59,65.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.4,102.7c0.4,0.8,0.9,1.3,0.1,2c-0.4,0.4,0.2,0.6,0.5,0.7c1.5,0.6,3,1.2,4.6,1.8c0.8,0.3,1.5,0.7,1.4,1.7 c0,0.5,0.3,0.7,0.7,0.7c0.5,0,0.4-0.4,0.4-0.7c0.4-1.3-0.2-2.3-1.2-3.1c1-0.7,2-0.1,2.1,1.3c0.1,0.7,0,1.3-0.2,2 c-0.1,0.5-0.2,0.9,0.5,1.1c0.7,0.1,0.7-0.5,0.7-0.8c-0.3-1.4,0.9-1.1,1.6-1.6c-0.2,0.8-0.4,1.5-0.6,2.1c-0.1,0.3-0.1,0.5,0.2,0.6 s0.5,0,0.6-0.2c0.4-0.7,1.2-0.8,1.8-0.9c0.4-0.1,1.1,0.7,1.2,1.4c0.1,0.3,0,0.6,0.5,0.7c0.5,0,0.5-0.4,0.5-0.7 c0.1-1.6,1-3.1,0.6-4.8c-0.1-0.4,0.8-0.5,1.5-0.9c-0.4,2.1-0.8,3.9-1.2,5.7c-0.4,1.9-0.4,1.9-2.3,1.5c-2.4-0.6-4.9-0.9-7.3-1.9 c-0.5-0.2-0.7,0-1,0.2c-1.4,1-1.9,0.8-2.6-0.7c-0.3-0.6-0.6-0.9-1.1-1.1c-1.2-0.5-2.4-1-3.6-1.5c-0.3-0.1-0.8-0.1-0.5-0.7 c0.2-0.5,0.5-0.3,0.8-0.2c1.6,0.7,3.2,1.3,4.8,2c0.4,0.2,0.9,0.2,0.6,0.9c-0.1,0.2,0.1,0.5,0.3,0.6c0.3,0.1,0.4-0.1,0.6-0.4 c0.6-0.9,0.5-1.2-0.5-1.6c-1.8-0.8-3.5-1.5-5.3-2.2c-0.6-0.2-0.8-0.4-0.5-1.1C23.7,104.3,24,103.6,24.4,102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2,115.1c1.5,0,1.8-0.4,1.6-2c-0.1-0.9-0.3-1.8,0.9-2.2c0,0.2,0,0.3,0,0.5c0,1.8,0.1,1.8,1.9,1.6 c0.5-0.1,0.6-0.2,0.3-0.6c-0.2-0.3-0.4-0.7-0.6-1c-0.2-0.3-0.4-0.7-0.6-1.1c0.8,0,1.4-0.1,1.8-0.7c0.1-0.2,0.3-0.3,0.5-0.1 c0.5,0.6,1.1,0.6,1.9,0.6c-0.4,0.7-0.7,1.3-1,2c-0.1,0.2-0.2,0.5-0.2,0.6c0.6,0.4,1.2,0.1,1.8,0.1c0.5,0,0.5-0.3,0.4-0.6 c-0.2-1.6,0.1-3.3-0.5-4.9c-0.2-0.5,0.7-0.7,1.1-1.2c0.3,2.5,0.2,4.9,0.4,7.2c0.1,0.7-0.4,0.5-0.8,0.5c-1.9,0-3.7,0.1-5.6,0.1 c-0.5,0-0.8,0.1-1,0.6C53.1,115.8,52.2,116,51.2,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9,110.1c-0.1,0.7-0.1,1.3-0.1,1.8c0,0.4-0.3,1,0.5,1s0.6-0.7,0.5-1c-0.4-1,0.3-1.2,1-1.7c0,0.4,0,0.8,0,1.1 c0,2.5,0,2.5-2.5,2.3c-1.5-0.1-3.1-0.1-4.6-0.2c-0.5,0-0.6-0.1-0.5-0.7c0.2-1,0.6-1.9,1.7-2.2c0.4-0.1,0.5-0.3,0.5-0.7 c0.1-0.7,0.3-1.5,0.2-2.2c-0.1-1,0.4-1.3,1.3-1.6c-0.2,2-0.3,3.8-0.4,5.7c0,0.4-0.1,0.8,0.6,0.8c0.6,0,0.9-0.3,0.7-0.8 C48.2,110.8,49.2,110.7,49.9,110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9,100.7c0.6,1.2,1.1,2.3,1.6,3.3c0.2,0.4,0.4,0.9,0.9,0.6c0.5-0.2,0.1-0.7,0-1c-0.4-1-0.9-2-1.4-3 c0.9-0.3,1.3,0,1.6,0.9c0.2,0.6,0.5,1.1,0.8,1.7c0.2,0.3,0.4,0.7,0.1,1.1c-0.2,0.4-0.1,0.6,0.4,0.7c0.6,0.2,0.8,0.8,0.8,1.3 c0.1,0.5-0.6,0.4-0.9,0.7c-0.2,0.2-0.4,0.2-0.6,0.3c-0.4,0.1-0.7,0.7-1.1,0.3c-0.4-0.4-0.7-0.9-0.5-1.5c0.2-0.4,0.1-0.6-0.3-0.8 c-0.7-0.4-0.8-1.3-1.2-1.9c-0.3-0.4-0.3-0.9-0.7-1.4C80,101.7,80.7,101.3,80.9,100.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,102.9c0.8,0.2,1.4,0.5,1.5,1.6c0.2,1.3,0.9,2.5,1.3,3.7c0.1,0.3,0.1,0.6,0.5,0.5s0.5-0.3,0.4-0.7 c0-0.6,0.4-1.2,0.8-1.5c0.5-0.4,1.2,0,1.7,0.4c1,0.7,0.9,1.3-0.2,1.7c-1,0.4-1.9,0.8-2.9,1.2c-0.3,0.1-0.6,0.2-0.8-0.2 C76.6,107.4,75.5,105.2,75,102.9L75,102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,105.3c0.8-1,1.4-2.1,2.9-1.6c0.3,0.1,0.4-0.3,0.6-0.5c0.3-0.7,0.8-1.3,1-2c0.3-0.9,0.8-1.3,1.8-1.1 c-1,2.1-2.1,4.2-3.1,6.3c-0.2,0.4-0.4,0.4-0.7,0.2C20,106.2,19.2,105.8,18.4,105.3z M20.6,105.4c0.4,0,0.5-0.3,0.5-0.5 c0.1-0.3-0.2-0.3-0.4-0.3c-0.3,0-0.6,0.1-0.6,0.4C20,105.3,20.4,105.2,20.6,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,107.5c0.3,1.1,0.6,2.1,0.8,3.1c0.1,0.5,0.1,0.8-0.5,1c-1.5,0.3-3,0.7-4.5,1.2c-1.4,0.4-2.1-0.7-3.2-1.3 c1.1-0.4,1.7-1.1,2.2-2.1c0.1,0.5,0,0.9-0.2,1.2c-0.4,0.8-0.1,1.4,0.7,1.3c1.4-0.2,2.8-0.5,4.2-1c0.8-0.3,0.2-1,0.1-1.4 C70.7,108.5,70.6,108.5,71.3,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6,106.1c0.9,0.3,1.1,0.8,1.1,1.5c0.1,1.7,0.2,3.4,0.4,5c0,0.4,0.1,0.7-0.4,0.7c-0.5,0.1-0.6-0.3-0.6-0.6 C61.9,110.6,61.7,108.4,61.6,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,105.7c0.7,0.5,0.9,1.1,0.7,1.9c-0.3,1.6-0.5,3.3-0.7,5c0,0.3,0,0.6-0.5,0.6c-0.4-0.1-0.6-0.2-0.5-0.6 C42.1,110.2,42.4,108,42.8,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6,104.1c0.9,0.2,1.2,0.7,1.4,1.5c0.3,1.6,0.8,3.3,1.2,4.9c0.1,0.3,0.2,0.6-0.3,0.7c-0.4,0.1-0.6,0-0.7-0.3 C72.6,108.6,72.1,106.4,71.6,104.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5,99.5c1,0,1.4,0.5,1.8,1.2c0.6,1.5,1.4,2.9,2.1,4.3c0.2,0.4,0.3,0.7-0.2,0.9c-0.5,0.2-0.6-0.2-0.7-0.5 C85.5,103.5,84.5,101.6,83.5,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,107.3c0.3,1.1,0.6,2.1,0.9,3.1c0.5,1.6-0.1,2.3-2,2.1c1.7-0.5,1.2-1.6,0.9-2.6C74.7,108.5,74.7,108.5,75.3,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6,115c-0.1,0.3-0.4,0.6-0.6,0.4c-0.4-0.5-1.3,0.6-1.5-0.5c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,1.7,0,1.8,0.1 C48.6,114.8,48.6,114.9,48.6,115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,106.3c-0.8,0.2,0.6,1.2-0.4,1.4c-0.3,0.1-0.6-0.3-0.5-0.4c0.7-0.4-0.5-1.4,0.5-1.6C45.7,105.7,46,105.9,45.9,106.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,106.9c-0.7,0.5-1.2,0-1.8,0.2c-0.2,0.1-0.4-0.3-0.2-0.6c0.2-0.3,0.4-0.4,0.7-0.2C35.1,106.6,35.4,106.9,36,106.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,108.5c-0.3-0.2-1,0.5-1-0.2c-0.1-0.8,0.7-0.2,1-0.4c0.3-0.2,0.6-0.3,0.8,0c0.1,0.1,0.1,0.3,0,0.5 C69.1,108.7,68.8,108.5,68.5,108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9,99.3c-0.4,0.2-0.3,0.9-0.9,1.1c-0.2,0.1-0.2-0.3-0.1-0.3c0.5-0.3-0.3-1.2,0.6-1.3C22.7,98.7,22.9,98.9,22.9,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1,115.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.4,0.5-0.4s0.5,0.2,0.4,0.4C50.5,115.4,50.3,115.6,50.1,115.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 75,
    y1: 1056.9,
    x2: 75,
    y2: 1056.9,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M75,102.9L75,102.9L75,102.9z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2,93.6c-0.3,0-0.6,0-0.9-0.1c0-0.1,0-0.2,0.1-0.2C30.6,93.1,30.9,93.2,31.2,93.6z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6,93.8c0,0.1,0.1,0.1,0,0.3c-0.1,0.1-0.2,0-0.3,0C74.3,93.8,74.4,93.8,74.6,93.8z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7,9.1c0,0.1,0,0.2,0,0.2c-0.3,0.2-0.5,0.6-0.9,0.4c-0.2-0.1-0.2-0.3-0.1-0.5C40.9,8.8,41.3,8.8,41.7,9.1L41.7,9.1z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4,62.7c0-1.8-0.4-3.7-0.6-5.6c0-0.7-0.2-1.3,0-2c6.5,0.4,12.9,0.7,19.4-0.9c-0.4,1.4-1.1,2.6-1.9,3.6 c-3.6,4.9-10.6,7.1-16.3,5.1C48.7,62.9,48.6,62.8,48.4,62.7z M63,58.5c-0.3,0-0.5,0.1-0.4,0.4c-1.9-0.1-3.5,1-5.3,1.5 s-3.6,1.2-5.4,1.9c0.7,0.6,1.4,0.2,2.3,0.2c2.9-0.1,5.5-1.1,7.9-2.9c0.3-0.2,0.6-0.4,0.7-0.8C62.8,58.9,63,58.7,63,58.5L63,58.5 C63,58.4,63,58.4,63,58.5z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4,63.8c-0.4-0.2-0.6-0.5-0.8-0.8c0.7-0.2,1.4,0.5,1.9-0.2l0.1,0.1c-0.1,0.4-0.4,0.6-0.9,0.5c-0.3-0.1-0.4,0.1-0.2,0.3 C59.5,63.7,59.5,63.7,59.4,63.8z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7,43.3c0.3-0.6-0.2-0.9-0.3-1.3c-0.1-0.4-0.6-0.7-0.4-1.2c0.6,0.6,0.8,1.4,1.2,2.2C66.3,43.4,66.2,43.6,65.7,43.3z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1,51.6c-0.8,0.6-0.8-0.2-1-0.6c0.5,0,0.8,0.4,1.2,0.5C69.2,51.5,69.1,51.5,69.1,51.6z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1,32.2c0.3,0.5,0.3,0.8-0.2,0.9C51.8,32.8,52,32.5,52.1,32.2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2,51c0.2-0.1,0.4-0.4,0.7-0.3c0.1,0.4-0.2,0.6-0.3,0.9l-0.1-0.1c0-0.2,0.1-0.4-0.2-0.4C37.3,51.1,37.3,51.1,37.2,51z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9,51.7c-0.3,0.4-0.5,0.2-0.8-0.1l0.1-0.1c0.2,0,0.3,0.1,0.5,0.1C69.8,51.6,69.8,51.6,69.9,51.7z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7,51.7c0,0.2-0.1,0.4-0.1,0.5l-0.1,0.1c-0.3-0.3-0.1-0.5,0.1-0.8C37.6,51.6,37.6,51.6,37.7,51.7z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3,52.7c0.1-0.1,0.2-0.4,0.4-0.1c0.1,0.1-0.1,0.3-0.3,0.2C68.4,52.8,68.4,52.7,68.3,52.7z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M65.3,40.7c-0.2,0-0.2-0.1-0.1-0.3C65.3,40.5,65.3,40.6,65.3,40.7z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,52.2c0.1,0.1,0.1,0.1,0.2,0.2l-0.1,0.1C37.5,52.4,37.5,52.4,37.5,52.2C37.5,52.3,37.5,52.2,37.5,52.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5,52.8c-0.1,0.1-0.1,0.1-0.2,0.2l-0.1-0.1C68.3,52.8,68.3,52.8,68.5,52.8C68.4,52.7,68.4,52.8,68.5,52.8z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5,62.7c0-0.1,0.1-0.2,0.1-0.3l0.1,0.1C60.7,62.6,60.6,62.7,60.5,62.7L60.5,62.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.3557,
    y1: 960.9696,
    x2: 47.8166,
    y2: 960.9696,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M47.8,7.1c0,0.2-0.2,0.3-0.3,0.2c-0.4-0.4-1,0.3-1.2-0.2c-0.1-0.4,0.4-0.5,0.7-0.5C47.4,6.6,47.7,6.7,47.8,7.1 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.9876,
    y1: 963,
    x2: 46.2634,
    y2: 963,
    gradientTransform: "matrix(1 0 0 1 0 -954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M46.2,9.1c-0.1,0-0.2,0-0.1-0.2c0,0,0.2,0,0.3,0C46.2,9,46.2,9,46.2,9.1z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M20.6,105.4c-0.2-0.1-0.5-0.1-0.5-0.4s0.3-0.4,0.6-0.4c0.2,0,0.5,0,0.4,0.3C21,105.1,21,105.4,20.6,105.4z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3,36.9c-0.4,1.9-0.6,3.7-0.9,5.4c-0.1,0.4-0.4,0.5-0.6,0.5c-1.5-0.3-2.8,0-4.1-0.5c-0.5-0.1-0.6-0.4-0.4-0.9 c1.2-2.5,3.1-4.3,5.5-5.6C48.8,35.1,47.8,36.8,48.3,36.9z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3,57.6c0,0.6-0.5,0.9-0.9,1.1c-2.9,2.4-6,3.9-9.6,4c-0.9,0-1.9,0.6-2.8-0.3c2.2-0.9,4.4-1.9,6.6-2.7 C59.9,59.1,61.8,57.5,64.3,57.6C64.2,57.6,64.3,57.6,64.3,57.6z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4,57.9c0,0.3-0.1,0.4-0.4,0.5l-0.1-0.1C61.9,58,62.1,57.8,62.4,57.9L62.4,57.9z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4,57.9L62.4,57.9C62.4,57.8,62.4,57.8,62.4,57.9L62.4,57.9z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1,37.1c-0.5,0.2-1,0.2-1.4-0.4c0,0.7-0.2,1.1-0.8,1.2c0,0.5,0.5,0.2,0.7,0.5c-0.6,0.2-1-0.2-1.6-0.2 c0.3-0.5,0.9-0.4,1.2-0.7c-1.7-2.9-7.9-5.9-11.5-5.7c0.1,0.5,0.3,1,0.4,1.5c-0.6-0.2-1-0.8-1.8-0.8c0.5-0.3,0.8-0.1,1.2,0 c-0.2-0.6,0-1.1,0.7-1.6c-0.9,0.1-1.4-0.1-1.5-0.9c-0.3,0.6-0.5,1.1-1.3,0.9c-0.1,0.3,0.1,0.3,0.2,0.5c0.2,0.2,0.5,0.4,0.3,0.6 c-0.3,0.3-0.1-0.3-0.4-0.3c-0.8,0-1.5,0.1-2.3,0.3c-3.1,0.7-5.9,2.1-8.2,4.3c-1,0.9-1,0.9,0.3,1.4c-0.4,0.4-1,0.2-1.3,0.6 c-0.4,0.4,0,1-0.3,1.6c-0.3-0.4-0.5-0.7-0.9-1.1c-1.7,2.4-2.7,5-3.1,7.9c-0.2,1.3-0.1,2.6,0,4c0,0.7,0.3,0.9,0.9,0.5l0.1,0.1 c-0.5,0.8-1,0-1.6,0c0.6,0.8,0,1-0.6,1.5c0.9-0.1,1.2,0.3,1.3,1.4c0.3-0.9,0.6-1.3,1.3-1.2c0.2,0,0-0.2,0-0.3l0.1-0.1 c0.3,0.2,0.5,0.5,0.8,0.7l-0.1,0.1c-1.7,0-1.7,0-1,1.6c1.3,3.3,3.6,5.8,6.5,7.8c0.2,0.2,1.3,0.2,0.4,0.9v0.2c0.9,0.1,0.4,1,0.8,1.4 c0.2,0.5-0.2,0.5-0.6,0.8c0.3-1.1,0.2-1.9-0.9-2.1c-0.1,0-0.2-0.1-0.2-0.2c0.9-1-0.4-1-0.7-1.2c-2.5-2-4.3-4.5-5.8-7.4 c-0.4-0.8-0.5-2.1-1.9-2.2c-0.3,0-0.3-0.5,0-0.6c0.7-0.3,0.5-0.8,0.5-1.4c0.2-3.9,0.4-7.9,2.6-11.4c0.4-0.7,0.4-0.7-0.4-0.7 c0.1-0.6,0.9-1,0.8-1.8c0.9,0.4,0.1,0.8-0.1,1.6c1-0.9,1.3-0.1,1.8,0.4c-0.2-0.9,0.1-1.3,0.8-1.5c-0.8-0.1-0.9-0.6-1-1.4 c-0.3,0.6-0.7,0.8-1.3,0.5c-0.3-0.2-0.1,0.2-0.2,0.4c-0.4-0.1-0.6-0.4-0.7-0.9c0.9,0.3,1.6,0.4,2.3-0.5c0.5-0.7,0.2,0.5,0.7,0.4 c2-1.9,4.3-3.4,7-4.3c0.8-0.3,1.7-0.4,2.5-0.7c0.3-0.1,1,0.3,0.9-0.6c0,0,0.2-0.1,0.3-0.1c1.2,0.3,1.5-0.6,1.7-1.4 c0.4,0.2,0.4,0.6,0.5,0.9c0.1,0.2,0.1,0.5,0.3,0.5c1.2-0.1,2,0.8,3.2,1c2.8,0.5,5.3,1.9,7.5,3.8c0.3,0.3,0.6,1.2,1.3,0.4 c0,0,0.3,0.1,0.3,0.2C67,36.7,67.6,36.9,68.1,37.1z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7,8.7c0.7-0.8,1.5-1.6,2.2-2.4c1.6-2,4-2.6,6.4-3.2c5.6-1.3,10.5,2.5,13,6.6c1.9,3.1,3.1,6.4,4.8,9.6 c0.5,0.9,1.1,1.8,1.7,2.7c1.6,2.4,3.9,2.8,6.6,2.3c1.8-0.4,3.4-1.1,5-2c0.9-0.5,1.9-0.9,2.8-1.4c2.8-1.5,5.4-1,7.8,1 c3.7,3.1,6.3,6.9,7.7,11.5c0.3,0.8,0.4,1.7,0.4,2.6C98,41.4,98,46.7,97.9,52.1c0,1.9,0.1,3.7,0.9,5.4c-0.4,0.4-0.7-0.2-1.1,0.1 c0.5,3.8-0.6,7.9,0.7,11.8c-1-0.2-0.9,0.5-0.8,1.3c0,3.2,0,6.3,0,9.5c0,0.7,0.2,1.4,0.3,2.2c0,0.3,1,1.1-0.3,1c0,0-0.1,0.5-0.1,0.8 c-0.1,3.4-0.1,6.7-0.2,10.1c0,2.6-0.1,5.3-0.1,7.9c0,0.9,0,1.8,0.2,2.7c0.1,0.7-0.1,1-0.8,0.7c-3-1.3-5.3-3.3-5.3-7.1 c0-0.9-0.1-1.9-0.2-2.8c0-0.3-0.2-0.5-0.4-0.6c-1.7-1.1-3.1-2.3-3.4-4.5c-0.1-0.4-0.4-0.5-0.6-0.6c-2-1.1-3.2-2.7-3.8-4.9 c-0.1-0.3-0.1-0.6-0.5-0.9c-2-1.5-3.3-3.5-3.3-6.1c0-0.5-0.2-0.8-0.6-1c-1.6-1.2-2.6-2.9-2.4-4.8c0.3-2.5-0.7-4.2-2.6-5.9 c0.4,6.5,1.1,12.9,3.1,19C75,85.5,75,85.5,75.4,87c0.5,1.8,1.2,3.6,1.9,5.4c0.3,0.7,1,0.8,1.5,1.2c0.3,0.2,0.4-0.2,0.6-0.4 c1.3-1.2,1.9-1.1,2.7,0.5c0.2,0.3,0.5,0.4,0.7,0.6c2.3,1.5,4.6,2.9,6.9,4.3c0.6,0.4,0.8,0.7,0.8,1.4c0,3.2,0,6.3,0,9.5 c0,0.6-0.2,0.9-0.7,1.2c-6,3.4-12.3,5.8-19,7.4c-5.1,1.2-10.3,1.8-15.5,1.9c-0.8,0-1.2,0.5-1.7,0.9c-0.2,0.2-0.4,0.6-0.8,0.2 c-1.3-1.6-3.2-1.1-4.9-1.3c-11-1.1-21.6-3.6-31.3-9.3c-0.6-0.4-0.8-0.8-0.8-1.5c0-3.1,0-6.2,0-9.4c0-0.6,0.2-0.9,0.7-1.2 c2.3-1.4,4.5-2.8,6.7-4.2c0.4-0.3,0.8-0.5,1-1c0.7-1.2,1.5-1.3,2.5-0.3c0.2,0.2,0.4,0.4,0.6,0.6c0.3-0.6,1.1-0.4,1.4-1 c0.9-2.1,1.8-4.2,2.4-6.4c0.4-1.4-0.9-0.3-1.1-1c1.4-6.1,2.7-12.4,3.2-18.9c-1,0.9-1.8,1.6-2.6,2.4c-0.2,0.2-0.2,0.4-0.2,0.7 c0,0.8-0.1,1.7,0,2.5c0.1,2.1-0.8,3.8-2.4,5.1c-0.4,0.3-0.6,0.6-0.6,1.2c-0.3,2.4-1.3,4.4-3.3,5.8c-0.3,0.2-0.6,0.4-0.6,0.8 c-0.3,2.2-1.6,3.7-3.4,4.7c-0.6,0.3-1,0.7-1.2,1.4c-0.5,1.7-1.6,3-3.2,3.8c-0.5,0.3-0.7,0.6-0.6,1.1c0.1,1.5,0,2.9-0.4,4.4 c-0.7,2.5-2.5,4-4.7,5c-1,0.5-1.5,0.1-1.2-1.1c0.4-2,0.3-4,0.3-6c0.1-4.7,0-9.3,0-14c0-0.7,0-1.3-1.2-0.8c0.8-1.1,0.9-2,0.9-3 c0-3.3,0-6.6,0-9.9c0-0.4,0.4-1.1-0.5-1.2c-0.3,0,0-0.4,0.1-0.5c0.5-0.8,0.5-1.7,0.5-2.6c0-2.7,0-5.4,0-8.1c0-0.5,0.2-1.2-1-0.3 c0.8-1.6,0.9-2.9,0.9-4.3c0-5.4,0.1-10.9,0-16.3c-0.1-2.7,0.6-5.1,2-7.3c1.8-3,3.7-5.8,6.4-8.1c2.3-1.9,5.5-2.3,8.2-0.4 c3.7,2.6,7.7,4.1,12.3,3.8c2.7-0.2,5.2-0.7,7.2-2.8c1.6-1.7,1.7-4.1,0.4-6c-0.2-0.3-0.5-0.5-0.6-0.8c-1-2.3-3.1-1.4-4.8-1.7 c-0.3,0-0.3,0-0.4,1c-1.7-1.8-1.4-4.3,0.5-5.4c0.1,0.1,0.1,0.1,0.2,0.2c-0.6,0.6-0.9,1.4-0.7,2.3c0.1,0.4,0.3,0.7,0.7,0.5 c1.4-0.6,2.8-0.8,4.3-0.4c0.4,0.5,1.1,0.5,1.6,0.9c2.8,2.3,3.1,5.7,1.1,8.7c-2,3.1-5,4.8-8.8,5c-4.4,0.3-8.5-0.6-12.1-3.2 c-0.8-0.6-1.7-1-2.6-1.4c-1.6-0.7-3-0.4-4.4,0.7c-2.4,2.1-4.5,4.5-6.4,7.1c-1.7,2.4-2.7,4.9-2.5,7.9c0.2,4.7,0.3,9.4,0.4,14.2 c0,0.8-0.1,1.5-0.2,2.5c1.5-1.1,2.5-2.3,2.7-3.9c0.3-2.1,0.1-4.2,0.2-6.3c0.1-1.1,0.3-2.2,1.5-3.1c-0.1,3.7,0.4,7.1,0.1,10.6 c1.6-0.8,2.5-2.1,2.8-3.8c0.3-1.5,0.2-3,0.2-4.5c0.1-1.3,0.4-2.6,1.4-3.7c0,3,0.4,6,0.2,9.3c3.4-2.9,2.6-7.1,4.2-10.7 c0,2.9,0.4,5.5,0,8.3c3.4-2.3,2.9-5.8,3.7-9.1c0.6,2.3,0.5,4.5,0.2,6.7c1.4-1,1.6-1.4,3.3-6.9c-0.4,9.7,0.2,19.3,0.2,29.2 c1.8-1.8,2.5-3.7,2.2-5.9c-0.6-5.7-1.2-11.4-0.4-17.2c0.3-1.8,0.5-3.7,1.4-5.4c0,0.4,0,0.8,0,1.2C34.2,42,34,45,34.1,47.9 c0.1,5,1.2,10,1.7,15c0.3,2.7,0.2,5.3-0.4,8c-0.4,1.9-0.8,3.8-1.2,5.7c-0.6,2.2-1.2,4.5-1.9,6.8c1.2-0.7,2.2-1.3,3.5-2 c-0.4,1-0.3,1.8-0.5,2.7c1-0.5,1.1-1.7,2.1-2.2c0,1,0,2,0,3.2c0.9-2.3,1.8-4.3,2.9-6.2h0.1v-0.1c0.1-0.1,0.1-0.2,0.2-0.3 c0.4-0.6,0.9-1.2,1.3-1.8c0.8-1.2,1.9-2.1,3.1-2.7c2.9-1.4,5.7-0.8,8.2,1.3c0.5,0.5,0.8,0.4,1.3,0c3.6-3,7.6-2.6,10.7,1 c1.3,1.5,2.1,3.2,3.1,4.8c0.6,1.4,1.2,2.9,1.7,4.3c0.1,0,0.1,0,0.2,0c0-0.9,0-1.9,0-3c0.7,1,1.3,1.7,2,2.7c0.1-1.2-0.3-2.1,0-3.1 c1,0.6,1.8,1.1,2.9,1.7c-0.5-2-0.9-3.7-1.5-5.4c-0.2-1-0.3-2-0.5-2.9c-0.7-3.4-1.7-6.8-1.4-10.2c0.2-2.9,0.6-5.7,1.1-8.5 c1-5.7,1-11.3,0.3-17c0-0.2-0.1-0.5,0.3-0.6c0.4,0.4,0.4,0.9,0.6,1.4c0.7,2.7,0.9,5.4,1,8.1c0.1,4.1-0.5,8.2-0.9,12.2 c-0.3,2.4,0.6,4.8,2.4,5.8c0.1-7.1,0.2-14.2,0.3-21.3c0-1.4,0.1-2.8-0.2-4.2c-0.2-1.1-0.3-2.3,0.3-3.5c0.5,2.6,0.9,5.1,3.2,7.1 c-0.4-2.4-0.4-4.6,0.2-7c0.6,3.6,0.5,7.2,3.8,9.5c-0.7-2.8-0.3-5.5-0.2-8.4c0.3,0.4,0.4,0.6,0.4,0.9c0.5,2.1,0.9,4.2,1.4,6.3 c0.3,1.3,1.1,2.3,2.3,3.1c0-3.2,0-6.2,0-9.2c0.1,0,0.2,0,0.3,0c0.8,1.1,1.2,2.4,1.2,3.8c0,1.5-0.1,3,0.2,4.5 c0.3,1.7,1.3,2.9,2.8,3.8c-0.2-3.6,0.1-7,0.1-10.6c0.8,0.5,1.1,1.1,1.3,1.8c0.4,1.8,0.2,3.7,0.2,5.5c-0.1,2.6,0.8,4.6,3,6l0,0H97 c-0.3-2.6-0.2-5.2-0.1-7.8c0.2-2.7,0-5.5,0.2-8.2c0.1-1,0.2-2.1-0.1-3.1c0-1-0.3-1.9-0.8-2.7c-2.1-4.1-5-7.4-8.5-10.3 c-1-0.8-2.1-0.8-3.3-0.5c-1.4,0.4-2.7,1.2-3.9,2.1c-1.3,0.8-2.7,1.3-4.3,1.6c-3.9,0.8-7.2,0.2-9.8-3.1c-1.3-1.6-2.3-3.4-3.1-5.3 c-1.7-4.3-4.3-7.8-8.4-10.2c-0.1-0.1-0.2-0.2-0.3-0.3c1-0.3,1.8,0.6,2.8,0.4l-0.1,0.1c0,0,0.1,0,0.1,0.1c0-0.1,0-0.1-0.1-0.2 c-1.8-1.6-3.6-2.9-6.1-2.9C47.1,4,43.8,5,41.3,8c-0.5,0.3-0.9,0.6-1.4,0.9C39.8,8.8,39.8,8.8,39.7,8.7z M10.1,74.7 c-0.1,0.3-0.1,0.7,0,1c-0.1,1.4,0.2,2.9-0.7,4.4c1.5-0.5,2.3-1.3,2.9-2.4c0.9-1.5,0.7-3.2,0.6-4.9c0.3-1.4-0.3-2.8-0.2-4.3 c0-0.6,0.4-1.6-0.1-1.8c-0.5-0.2-1.1,0.6-1.7,1c-0.4,0.3-1,0.4-0.9,1.1c0.1,1.8,0.1,3.6,0.1,5.3C10.1,74.3,10.1,74.5,10.1,74.7z  M95.8,73.4c0.4-1.4,0.1-2.9,0.1-4.4c0-0.1-0.1-0.3-0.2-0.4c-0.9-0.6-1.8-1.2-2.8-2c0,2.4,0,4.5,0,6.6c-0.1,1.9-0.1,3.8,1,5.4 c0.7,1,1.4,1.6,2.5,1.8C95.5,78.2,96,75.8,95.8,73.4z M91.4,70.8c0-1.4,0-2.8,0-4.2c0-0.2,0-0.4-0.2-0.5c-0.9-0.6-1.8-1.3-2.8-1.9 c0,2.3,0,4.5,0,6.6c0,0.8-0.1,1.6,0,2.4c0.1,2.1,1.2,3.5,3.1,4.6C91.3,75.3,91.4,73.1,91.4,70.8z M17.5,70.1 c-0.3-2.1,0.2-4.2-0.1-6.5c-0.9,0.7-1.8,1.3-2.6,1.9c-0.3,0.2-0.4,0.5-0.4,0.8c0,1.9-0.1,3.8,0.1,5.8c0,1.7,0,3.4,0,5 c1.5-0.7,2.4-1.9,2.8-3.5C17.7,72.4,17.5,71.3,17.5,70.1z M84.5,70.3c0.3,1.4,1.2,2.4,2.5,3.1c0-1,0-2,0-2.9 c-0.1-2.2-0.3-4.4-0.2-6.6c0-0.3-0.2-0.5-0.4-0.6c-0.5-0.3-1-0.5-1.5-0.8s-0.8-0.3-0.8,0.4c0,1.4,0,2.7,0,4.1 C84.1,68.1,84,69.2,84.5,70.3z M19.1,69.9c0,0.9,0,1.9,0,3c1.4-0.9,2.3-2,2.5-3.5c0.4-0.6,0.3-1.3,0.3-1.9c0.1-2,0-3.9,0-6 c-0.9,0.5-1.7,0.9-2.4,1.3c-0.3,0.1-0.4,0.4-0.4,0.7C19.1,65.6,19.1,67.8,19.1,69.9z M74.4,94c0.3,0.4-0.2,0.6-0.3,0.9 c-0.6,1-1.3,2-1.8,3.2c1.3-0.2,1.2-1.5,2.1-1.9c0.4,0.4,0.4,1,0.4,1.5c0,0.7-0.1,1.5,0.1,2.2c0.2,0.6,0.5,0.7,1,0.7 c0.5-0.1,1-0.3,1-0.9c0-0.3-0.1-0.7-0.1-1c-0.1-1-0.7-2-0.7-3c0-1.6-0.1-1.6-1.5-1.8c0.7-1.3,1.4-0.2,2.2,0.1 c-0.2-1-0.3-1.9-0.7-2.6c-0.8-1.4-1.3-2.9-1.6-4.4c-0.2-1.2-1-1.8-1.8-2.5c-0.2,1.2,0,2.2-0.4,3.3c-0.5-0.5-0.9-1-1.3-1.4 c0.1,1.6,0.5,3.1,1.5,4.4c0.4,0.5,0.7,1,0.9,1.7C73.4,92.9,73.4,93.8,74.4,94z M63.8,78.5L63.8,78.5L63.8,78.5 C63.7,78.5,63.8,78.5,63.8,78.5c-0.2,0.1-0.1,0.3,0,0.4c0.6,2.2,1.3,4.5,1.9,6.7c1,3.2,1.6,6.6,3.4,9.5c0.3,0.5-0.2,0.5-0.4,0.6 c-0.9,0.3-1.9,0.4-2.9,0.1c-0.6-0.2-0.8,0-0.8,0.6c-0.1,1.3-1.4,2.2-2.7,1.9c-0.6-0.1-1.1-0.9-1.6-0.8s-0.7,1-1.3,1.4 c-1.3,0.8-2.5,0.6-4.1-0.8c-2,2.9-2.7,3.2-4.6,0c-0.3,0-0.4,0.4-0.6,0.5c-1.4,1.3-3.7,1.1-4.5-0.6c-0.3-0.7-0.5-0.7-1.1-0.3 c-1.9,1.1-3.2,0.5-3.7-1.6c-0.1-0.6-0.4-0.5-0.7-0.4c-0.9,0.3-1.8,0-2.7-0.1c-0.6-0.1-0.9-0.3-0.4-0.9c0.3-0.5,0.6-1,0.8-1.5 c1.5-3.5,2.2-7.2,3.4-10.7c0.4-1.3,0.9-2.6,1-4c-2.6,3.1-4.8,6.4-5.9,10.4c-0.2-0.3-0.3-0.5-0.5-0.8c-1.3,2.7-3.5,5-2.6,8.4 c-0.4-1.1-1.9-1.7-0.9-3.2c0.7-1,1.1-2.3,1.8-3.5c0.7-1,1.2-2.3,1.1-3.8c-0.6,0.4-0.8,1.1-1.5,1.4c-0.4-1-0.1-2.1-0.5-3.1 c-1.1,0.8-1.8,1.7-1.8,3.1c0,0.2-0.1,0.5-0.2,0.7c-0.7,1.7-1.4,3.3-1.9,5.1c-0.1,0.2-0.2,0.6,0.2,0.5c0.8-0.2,0.4,0.3,0.4,0.6 c0.1,1.5-0.5,2.9-0.9,4.4c-0.2,0.9,0.1,1.4,0.9,1.5c1,0.1,1-0.6,1.1-1.3c0.1-0.8,0.1-1.6,0.2-2.4c0-0.2,0-0.6,0.3-0.6 c0.3-0.1,0.4,0.2,0.6,0.5c0.3,0.4,0.5,0.9,0.9,1.3c0.2,0.1,0.5,0.3,0.5,0c0.1-1,0.3-0.4,0.5-0.1c0.5,0.7,1.3,1.2,2.1,1.4 c4.5,1.3,9.1,2.1,13.8,2.4c1,0,1.9,0.1,2.5,0.9c0.4,0.4,0.7,0.3,1-0.1c0.4-0.3,0.7-0.9,1.4-0.9c1.2,0,2.4-0.1,3.6-0.1 c3.6-0.2,7.2-0.8,10.7-1.9c3.4-1.1,4.6-4.4,3-7.6c-0.6-1.1-1.1-2.2-1.7-3.3c0-0.1-0.1-0.2-0.2-0.2c-0.2,0.2-0.2,0.6-0.6,0.7 c-0.5-2.4-1.6-4.6-2.9-6.7C66,80.9,65.1,79.5,63.8,78.5z M26.5,99.7c-0.2,0.8-0.4,1-1,0.6c-1.5-1-1.9-1.7-1.5-3.7 c0.1-0.3,0.2-0.6-0.1-0.9c-0.4-0.3-0.6,0.1-0.8,0.3c-1.7,1.2-3.5,2.4-5.2,3.6c-0.4,0.3-0.6,0.6-0.6,1.2c0.1,2.5,0,5,0.2,7.6 c0,0.7,0.2,1.1,0.8,1.4c4,2.2,8.2,3.9,12.6,5.1c6.4,1.8,13,2.9,19.7,3c0.7,0,1.3,0.2,1.7,0.8c0.4,0.5,0.7,0.4,1.1,0 c0.4-0.5,0.8-0.8,1.5-0.8c5.1,0,10.1-0.7,15.1-1.8c6.1-1.3,11.9-3.3,17.4-6.2c0.8-0.4,1.2-0.9,1.2-1.9c0-2.5,0-4.9,0.1-7.4 c0-0.4-0.1-0.7-0.5-1c-1.9-1.2-3.7-2.5-5.5-3.8c-0.5-0.3-0.7-0.2-0.7,0.4c0,0.3,0.1,0.6,0.1,0.9c0.2,0.9,0.1,1.9-0.7,2.4 c-0.5,0.3-0.9,1.8-1.9,0.5c0,0-0.2,0.1-0.3,0.2c-0.3,0.3-0.6,0.5-0.8,0.8c-0.5,0.5-0.8,0.7-1-0.2c-0.5,0.4-0.9,0.7-1.4,1.1 c-0.2,0.1-0.5,0.3-0.5,0.1c-0.1-0.8-1.2-1-1.2-1.8c0-0.7-0.2-0.8-0.9-0.6c-5.7,2.1-11.6,3.2-17.6,3.5c-0.8,0-1.5,0.1-2,0.8 c-0.5,0.6-1,0.5-1.5,0c-0.4-0.4-0.8-0.8-1.5-0.8c-1.6,0-3.2-0.2-4.8-0.4c-4.5-0.5-8.9-1.6-13.2-3.1c-0.6-0.2-0.9-0.3-1,0.4 c-0.1,0.9-1,1.2-1.4,1.9c-0.1,0.2-1-0.6-1.5-1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3,0.8-0.3,0.8-0.8,0.3C27.4,100.7,27,100.2,26.5,99.7z  M54.8,77.4c0.1,2.2,0.2,4.5,0.3,6.7c0.2,3.5,0.3,7,0.5,10.5c0,0.7,0.2,1.4,0.5,2c0.4,0.9,1.1,1.2,2.1,1.1c0.9-0.1,1.3-0.7,1.5-1.4 c0.2-0.6,0.2-1.3,0.1-2c-0.6-4.3-1.2-8.7-1.8-13.1c-0.2-1.6-0.4-3.2-0.7-4.9c0-0.3,0.1-0.7-0.5-0.8C55.8,75.4,54.8,76.4,54.8,77.4z  M51.2,78c0.1-1.7-0.1-2.1-1.5-2.5c-0.5-0.1-0.8-0.1-0.9,0.6c0,0.8-0.2,1.7-0.4,2.5c-0.6,4.4-1.2,8.8-1.8,13.2 c-0.2,1.3-0.5,2.7-0.3,4.1c0.1,0.9,0.6,1.6,1.5,1.7c1,0.1,1.7-0.3,2.1-1.2c0.2-0.5,0.4-1.1,0.4-1.7C50.7,89.1,50.9,83.6,51.2,78z  M13.1,80.1c-0.8,0.6-1.4,1.2-2.1,1.6c-0.6,0.3-0.7,0.7-0.7,1.3c0,5.6,0,11.2,0,16.8c0,0.7,0,1.5-0.3,2.2c-0.1,0.2-0.2,0.5,0,0.7 c0.3,0.2,0.5,0,0.7-0.2c1.5-1.1,2.4-2.5,2.3-4.4c0-3.9,0-7.8,0-11.8C13.1,84.2,13.1,82.2,13.1,80.1z M93,80.6 c-0.1,0.1-0.1,0.2-0.1,0.2c0,6,0,12,0,18c0,1.8,0.9,3,2.3,4c0.2,0.2,0.5,0.4,0.7,0.2c0.2-0.2,0.1-0.5,0-0.7 c-0.3-0.7-0.3-1.4-0.3-2.1c0-5.6,0-11.3,0-16.9c0-0.3,0.2-0.7-0.2-1C94.5,82,93.8,81.3,93,80.6z M51.9,77 c-0.2,6.2-0.3,12.3-0.5,18.4c0,1,0.3,1.8,1.1,2.5c0.4,0.4,0.7,0.3,1.1-0.1c0.6-0.7,0.8-1.5,0.7-2.3c-0.1-3.8-0.1-7.7-0.2-11.5 c0-2.3,0-4.7,0-7.1c-0.7,0.3-0.8,1-1.2,1.3C52.7,77.8,52.5,77.3,51.9,77z M48.2,75.6c0.1-0.4-0.1-0.6-0.6-0.7c-0.6,0-1,0-1.2,0.8 c-0.9,4.9-1.9,9.8-2.9,14.8c-0.3,1.6-0.8,3.2-1.2,4.8c-0.2,0.6-0.1,1.1,0.4,1.5s1.1,0.2,1.6,0c0.7-0.4,1-1.1,1.1-1.8 c0.4-2.6,0.8-5.2,1.2-7.9C47,83.3,47.6,79.5,48.2,75.6z M57.9,75.7c0,0.1,0,0.2,0,0.3c0.9,5.9,1.7,11.9,2.6,17.8 c0.1,0.8,0.1,1.7,0.7,2.5c0.6,0.7,1.3,0.9,2,0.6s0.6-1.1,0.4-1.7c-1.1-3.6-1.6-7.4-2.4-11.1c-0.6-2.8-1.1-5.6-1.7-8.4 c-0.1-0.7-0.7-0.6-1.1-0.6C58.2,75,57.8,75.1,57.9,75.7z M60.2,75.3c0.8,3.5,1.5,6.9,2.3,10.3c0.6,2.5,0.8,5.2,1.7,7.6 c0.5,1.5,1.3,1.9,2.8,1.7c0.5-0.1,0.6-0.2,0.4-0.6c-0.5-0.9-0.8-1.9-1-2.8c-1.1-4.3-2.3-8.6-3.2-13C62.8,76.8,61.8,75.9,60.2,75.3z  M45.8,75.3c-1.9,0.8-2.4,1.3-2.8,3c-0.6,2.6-1.2,5.1-1.9,7.7c-0.7,2.7-1.1,5.6-2.4,8.2c-0.3,0.7,0,0.7,0.5,0.8 c1.6,0.2,2.5-0.5,3-2.5c0.7-3,1.3-6.1,1.9-9.1C44.6,80.7,45.2,78,45.8,75.3z M88.4,77.7c0,3.7,0,7.2,0,10.6c0,2,1.4,4.1,3,4.5 c-0.1-0.9-0.2-1.7-0.2-2.6c0-2.8,0-5.6,0.2-8.4c0.1-1.3,0-2.4-1.6-2.8C89.3,78.8,88.9,78.4,88.4,77.7z M17.6,77.3 c-0.8,0.9-1.6,1.5-2.4,1.8c-0.4,0.2-0.5,0.4-0.5,0.8c0.1,2.9,0.1,5.7,0.1,8.6c0,1.3,0,2.6-0.2,4c1.9-1.2,3-2.6,3-4.7 C17.7,84.5,17.6,81,17.6,77.3z M86.9,87.8c0-4,0-7.8,0-11.6c0-0.2,0.1-0.5-0.2-0.6c-0.9-0.6-1.8-1.2-2.7-2.1c0,3.4,0,6.5,0,9.6 C84.1,85.1,85.1,86.6,86.9,87.8z M21.9,73c-0.8,0.9-1.5,1.5-2.4,1.9C19.2,75,19,75.3,19,75.6c0,3.8,0,7.7,0,11.6 c1.8-1,2.8-2.5,2.8-4.3C22,79.7,21.9,76.5,21.9,73z M17.6,51.5c-1,0.7-1.8,1.3-2.6,1.9c-0.3,0.2-0.6,0.4-0.6,0.8 c0,3.2,0.1,6.3-0.3,9.6c1.8-0.8,2.8-2.1,3.2-3.9C17.9,57.2,17.4,54.5,17.6,51.5z M9.7,66.3c1.9-0.8,3-2.2,3.3-4c0.3-2.6,0-5.1,0.1-8 c-0.9,0.6-1.6,1.1-2.3,1.5c-0.6,0.3-0.8,0.8-0.8,1.4C10,60.3,10.2,63.2,9.7,66.3z M88.8,52.1c0,2.7,0,5.1,0,7.5c0,2,1.5,4,3.3,4.6 c-0.4-3.2-0.3-6.3-0.3-9.5c0-0.2,0-0.5-0.2-0.6C90.7,53.4,89.8,52.8,88.8,52.1z M96.6,66.7c-0.1-0.5-0.1-0.9-0.2-1.3 c-0.4-2.6-0.1-5.2-0.2-7.8c0-0.4,0.1-0.8-0.3-1c-0.8-0.5-1.6-1.1-2.6-1.8c0,2.5,0,4.8,0,7.2C93.3,64.1,94.5,65.8,96.6,66.7z  M87.4,61.6c-0.4-3.4-0.2-6.6-0.2-9.7c0-0.3,0-0.5-0.3-0.6c-0.8-0.4-1.5-0.9-2.5-1.4c0,2.6-0.2,5,0.1,7.3 C84.7,58.9,85.5,60.6,87.4,61.6z M18.9,61.1c1.5-0.7,2.1-1.9,2.6-3.2c0.4-1,0.2-2.1,0.3-3.1c0-1.8,0-3.5,0-5.4 c-0.7,0.4-1.3,0.8-1.8,1c-0.8,0.3-1,0.9-1,1.7C19,55.1,19.1,58,18.9,61.1z M76.8,44.2c0,0.1-0.1,0.2-0.1,0.2c0,2.7,0,5.3,0.1,8 c0,1.9,0.9,3.3,2.7,4.2c-0.3-2.5-0.4-4.9-0.1-7.2c0.2-2.2-0.5-3.8-2.3-5.1C76.9,44.3,76.9,44.2,76.8,44.2z M27.2,56.1 c1.6-1,2.5-2.3,2.4-4.2c-0.1-1.2,0.1-2.5,0-3.7c-0.1-1.5,0.3-2.9,0.1-4.5c-1.7,1.2-2.8,2.6-2.5,4.9C27.4,51,27.2,53.5,27.2,56.1z  M83.3,59.2C82.8,56.4,83,53.7,83,51c0-1.8-0.7-2.8-2.5-3.6c0,2.1,0,4.2,0,6.3C80.4,56,81.3,57.7,83.3,59.2z M25.8,69.7 c-0.8,0.7-1.4,1.2-2.1,1.8c-0.2,0.2-0.2,0.4-0.2,0.6c0,3.1,0,6.3,0,9.6c1.5-0.9,2.2-2.1,2.3-3.6C25.8,75.3,25.8,72.6,25.8,69.7z  M25.8,46.8c-0.8,0.6-1.4,1.2-2,1.7c-0.3,0.2-0.4,0.5-0.4,0.9c-0.1,3.1,0.3,6.2-0.4,9.4c1.7-1.2,2.7-2.6,2.8-4.5 C25.8,51.9,25.8,49.5,25.8,46.8z M27.2,75.1c2-1.6,2.4-2.4,2.4-4.7c0-1.2,0-2.3,0-3.5c0-1.1,0-2.2,0-3.5c-0.7,0.9-1.3,1.5-1.9,2.1 c-0.3,0.2-0.4,0.5-0.4,0.9C27.2,69.3,27.2,72.1,27.2,75.1z M76.6,64.3c0,2.5,0,5,0,7.6c0,1.7,1.1,2.7,2.4,3.8c0-3.1,0-5.9,0-8.8 c0-0.3,0-0.6-0.3-0.8C77.9,65.6,77.3,64.9,76.6,64.3z M82.6,81.9c0-3.3,0-6.3,0-9.4c0-0.3,0-0.5-0.3-0.8c-0.6-0.5-1.2-1-1.9-1.6 c0,2.9-0.1,5.7,0,8.4C80.5,79.9,81.3,81,82.6,81.9z M25.6,59.2c-0.7,0.5-1.3,0.9-1.9,1.2c-0.2,0.2-0.4,0.4-0.4,0.7 c0,2.5,0,5-0.1,7.4c0,0.3,0.3,0.6,0.5,0.4c0.6-0.8,1.5-1.3,1.6-2.4C25.6,64.2,25.8,61.8,25.6,59.2z M80.3,59.7 c0.1,2.3-0.2,4.4,0.2,6.5c0.2,1.4,0.7,2.7,2.1,3.6c0-2.8,0-5.4,0-8.1c0-0.3-0.1-0.5-0.4-0.7C81.6,60.6,81,60.2,80.3,59.7z M79,64.3 c-0.3-1.9-0.2-3.6-0.2-5.2c0-0.3-0.1-0.5-0.3-0.7c-0.7-0.6-1.3-1.3-2-2.2c0,1.6-0.1,3.1,0,4.5C76.6,62.2,77.4,63.4,79,64.3z  M29.5,55.8c-0.7,0.7-1.2,1.5-1.9,2c-0.2,0.1-0.3,0.3-0.3,0.5c-0.1,1.5-0.1,3-0.2,4.5c0,0.6,0.3,0.5,0.6,0.3c1.1-0.7,1.7-1.7,1.7-3 C29.5,58.7,29.5,57.3,29.5,55.8z M24.2,97.3c0.1,0.8,0.2,1.5,1,1.6c0.7,0.1,1.2-0.3,1.4-1c0.3-1.1-0.6-2.2,0.2-3.3 c0.2-0.4-0.4-1.3-1-1.7c-0.6-0.5-1.2-0.3-1.2,0.5C24.6,94.7,24.7,96.1,24.2,97.3z M81.3,94.9c0-0.3,0-0.5,0-0.8 c-0.1-0.4,0.2-1-0.4-1.2s-1,0.2-1.3,0.7c-0.2,0.3-0.3,0.5-0.4,0.8c-0.1,0.2-0.4,0.7-0.2,0.7c0.9,0.1,0.3,0.6,0.3,1s-0.1,0.9-0.1,1.3 c0,0.6,0.1,1.2,0.7,1.5c0.4,0.2,0.9,0.3,1.2,0c0.5-0.4,0.7-1.1,0.5-1.7C81.4,96.5,81.2,95.7,81.3,94.9z M77.3,97.5 c0,0.5-0.1,1,0,1.5c0.1,0.6,0.5,1.1,1.2,0.9s0.9-0.7,0.5-1.3c-0.4-0.9-0.5-1.8-0.5-2.8c0-0.6,0.1-1.1-0.1-1.7 c-0.1-0.2-0.1-0.6-0.4-0.5c-0.7,0.1-1.3,0.4-1.5,1.1c-0.2,0.6,0,1,0.6,1.2c0.2,0.1,0.2,0.3,0.2,0.4C77.3,96.8,77.3,97.2,77.3,97.5z  M29.3,96.1c0.1-0.6,0.2-1.1,0.1-1.7c-0.2-0.7-0.8-1-1.4-1.1c-0.7,0-0.6,0.7-0.6,1.1c-0.2,1.4,0.1,2.8-0.6,4.1c-0.2,0.4,0,0.9,0.6,1 s1-0.2,1.1-0.9c0.1-0.8,0-1.7,0-2.5c0-0.2,0-0.4,0.3-0.5C29.1,95.6,29.1,95.9,29.3,96.1z M40.2,12.8c1.2,0.3,2.2-0.2,3.4-0.2 C42.2,11.5,41.6,11.5,40.2,12.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotary);
export default __webpack_public_path__ + "static/media/notary.6450ac2ca9f032a4a9c477b976fec077.svg";
export { ForwardRef as ReactComponent };